import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Card,
  Row,
  Col,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  ModalFooter,
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import { unitTypes } from "../../utils/constants";
import toast from "react-hot-toast";
import { calculatePrice, calculateTotalShipment } from "../../utils/commenController"
// View PopUp
import ViewPopUp from "./ViewPopUp";
import Index from ".";
function OpenPopUp({
  modal,
  handleShow,
  successMessage,
  quotationForm,
  selectedCustomer, 
  setSelectedCustomer,
  selectedSales,
  setSelectedSales,
  formattedCustomerData,
  formattedSalesPersonData,
  setSectionItems,
  sectionItems,
  setErrorMessage,
  errorMessage,
  openMainAccordion,
  setMainAccordionOpen,
  openSubAccordion,
  setSubAccordionOpen,
  sectionBaseSavedProducts,
  setSectionBaseSavedProducts,
  handleAddTermsAndCondition,
  handleRemoveTermsAndCondition,
  termsAndConditions,
  setTermsAndConditions,
  loadProductOptions,
  appTaxAmount,
  appStandardMarkup,
  setNotSectionBaseSaveProducts,
  notSectionBaseSavedProduct,
  appliedDiscount,
  setAppliedDiscount,
  totalTaxAmount, 
  setTotalTaxAmount,
  totalMarkupAmount, 
  setTotalMarkupAmount,
  isSectionActive, 
  setSectionActive,
  totalFinalAmount, 
  SetTotalFinalAmount,
  totalDiscountedPrice, 
  SetTotalDiscountedPrice,
  pricingPolicy,
  isEditQuotation,
  isEditQuotationSectionActive,
  searchInput, 
  setSearchInput,
  quotationProductData, 
  isUpdateProductButtonNoSection, 
  setIsUpdateProductButtonNoSection,
  isUpdateProductButtonSection, 
  setIsUpdateProductButtonSection,
  selectedProduct,
   setSelectedProduct
}) {
  const modalContentRef = useRef();
  const [sectionName, setSectionName] = useState("");
  const [subSectionNames, setSubSectionNames] = useState({});
  const [viewModal, setViewModal] = useState(false);
  const [viewPopUpSection, setViewPopUpSection] = useState({});


  const [noSectionFormInputErrorMessage, setNoSectionFormInputErrorMessage] = useState({})
  // ----------Terms & condition--------
  const [termsConditionAccordion, setTermsConditionAccordionOpen] = useState('');
  const [newTerm, setNewTerm] = useState('');
  const [totalFinalAmountWithoutDiscount , setTotalFinalAmountWithoutDiscount] = useState('0')
  const [totalFinalAmountWithoutCertificationFee , setTotalFinalAmountWithoutCertificationFee] = useState('0')
  const [sectionWiseTotalPrice, setSectionWiseTotalPrice] = useState({});
  const [distributorOptionDropdownInIsOpen, setDistributorOptionDropdownIsOpen] = useState(false);

  
  // handleDistributorOptionSort
  const handleDistributorSortOptionDropDown =()=>{
    setDistributorOptionDropdownIsOpen((prevState) => !prevState)
  }
  const handleDistributorSortOption = (section, sectionIndex, value)=>{
    switch(section){
      case 'MAIN_SECTION':
          // Deep copy arrays to avoid mutating original state directly
          let distributorListInMainSection = [...sectionItems[sectionIndex].distributorList].sort((a, b) => 
            parseFloat(value === 'PRICE' ? a.initial_price : a.lead_time) - 
            parseFloat(value === 'PRICE' ? b.initial_price : b.lead_time)
           );

        let distributorOptionsInMainSection = [...sectionItems[sectionIndex].distributorOptions].sort((a, b) => 
            parseFloat(value === 'PRICE' ? a.initial_price : a.lead_time) - 
            parseFloat(value === 'PRICE' ? b.initial_price : b.lead_time)
        );
        console.log("distributorOptionsInMainSection", distributorOptionsInMainSection);
        
        const basePriceInMainSection = distributorOptionsInMainSection?.[0].gpl_price || distributorOptionsInMainSection?.[0].price

        const {custom_fee, logistic_buffer_charge, logistic_fee } = distributorOptionsInMainSection?.[0].logistics
        setSectionItems((prev) =>
            prev.map((sectionItem,idx)=>
              sectionIndex === idx ?
              {
                ...sectionItem,
                distributorOptions: distributorOptionsInMainSection,
                distributorList: distributorListInMainSection,
                selectedSortOption : value,
                distributor: distributorOptionsInMainSection?.[0] || {}, 
                distributor_price_with_markup : calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', sectionItem.pricingPolicyOption, basePriceInMainSection,sectionItem.standard_markup,''),
                noDistributor : distributorOptionsInMainSection?.[0]?.noDistributor,
                markupFee :calculatePrice('MARKUP_FEE', sectionItem.pricingPolicyOption, basePriceInMainSection,sectionItem.standard_markup,''),
                markup_total_price :  calculatePrice('MARKUP_TOTAL_PRICE', sectionItem.pricingPolicyOption, basePriceInMainSection ,sectionItem.standard_markup,sectionItem.quantity),
                shipmentCharge :   calculateTotalShipment((distributorOptionsInMainSection?.[0]?.noDistributor ?  distributorOptionsInMainSection?.[0]?.initial_gpl_price : distributorOptionsInMainSection?.[0]?.initial_price), logistic_fee, custom_fee, logistic_buffer_charge),
                      // Price with markup=P+(P×M)
              } : sectionItem
            )
        )

        break;
      case 'SUB_SECTION':
        const {index, subIdx} =  sectionIndex;
         // Deep copy arrays to avoid mutating original state directly
         let distributorListInSubSection = [...sectionItems[index].subSections[subIdx].distributorList].sort((a, b) => 
          parseFloat(value === 'PRICE' ? a.initial_price : a.lead_time) - 
          parseFloat(value === 'PRICE' ? b.initial_price : b.lead_time)
         );

          let distributorOptionsInSubSection = [...sectionItems[index].subSections[subIdx].distributorOptions].sort((a, b) => 
              parseFloat(value === 'PRICE' ? a.initial_price : a.lead_time) - 
              parseFloat(value === 'PRICE' ? b.initial_price : b.lead_time)
          );
          const basePriceInSubSection = distributorOptionsInSubSection?.[0].price
          

          setSectionItems((prev) =>
              prev.map((sectionItem,idx)=>
                index === idx ?
                {
                  ...sectionItem,
                  subSections : sectionItem.subSections.map((subSectionItem, subSectionIndex)=>
                    subSectionIndex === subIdx ?
                    {
                      ...subSectionItem,
                      distributorOptions: distributorOptionsInSubSection,
                      distributorList: distributorListInSubSection,
                      selectedSortOption : value,
                      distributor: distributorOptionsInSubSection?.[0] || {}, 
                      distributor_price_with_markup : calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', subSectionItem.pricingPolicyOption, basePriceInSubSection,subSectionItem.standard_markup,''),
                      noDistributor : distributorOptionsInSubSection?.[0]?.noDistributor,
                      markupFee :calculatePrice('MARKUP_FEE', subSectionItem.pricingPolicyOption, basePriceInSubSection,subSectionItem.standard_markup,''),
                      markup_total_price :  calculatePrice('MARKUP_TOTAL_PRICE', subSectionItem.pricingPolicyOption, basePriceInSubSection ,subSectionItem.standard_markup,subSectionItem.quantity),
                      shipmentCharge :   calculateTotalShipment((distributorOptionsInSubSection?.[0]?.noDistributor ?  distributorOptionsInSubSection?.[0]?.initial_gpl_price : distributorOptionsInSubSection?.[0]?.initial_price), distributorOptionsInSubSection?.[0]?.logistics.logistic_fee, distributorOptionsInSubSection?.[0]?.logistics.custom_fee, distributorOptionsInSubSection?.[0]?.logistics.logistic_buffer_charge),
                    } : subSectionItem
                  )
                } : sectionItem
              )
          )
        
        break;
      case 'NO_SECTION':

          // Deep copy arrays to avoid mutating original state directly
          let distributorListInNOSection = [...selectedProduct.distributorList].sort((a, b) => 
              parseFloat(value === 'PRICE' ? a.initial_price : a.lead_time) - 
              parseFloat(value === 'PRICE' ? b.initial_price : b.lead_time)
          );

          let distributorOptionsInNOSection = [...selectedProduct.distributorOptions].sort((a, b) => 
              parseFloat(value === 'PRICE' ? a.initial_price : a.lead_time) - 
              parseFloat(value === 'PRICE' ? b.initial_price : b.lead_time)
          );
          const basePriceInNOSection = distributorOptionsInNOSection?.[0].price
          const distributerPriceInNOSection  = (parseFloat(basePriceInNOSection || 0) *
              (1 + parseFloat(selectedProduct.standard_markup || 0) / 100)
            ).toFixed(2)
          const markupFeeInNOSection = (
            parseFloat(basePriceInNOSection || 0) * 
            ((parseFloat(selectedProduct.standard_markup || 0)) / 100)
          ).toFixed(2);
          const quantityInNOSection = selectedProduct.quantity
          // Update the state
          setSelectedProduct(prev => ({
              ...prev,
              distributorOptions: distributorOptionsInNOSection,
              distributorList: distributorListInNOSection,
              selectedSortOption : value,
              distributor: distributorOptionsInNOSection?.[0] || {}, 
              distributor_price_with_markup : distributerPriceInNOSection ,
              noDistributor : distributorOptionsInNOSection?.[0]?.noDistributor,
              markupFee : markupFeeInNOSection,
				      markup_total_price : distributerPriceInNOSection * quantityInNOSection,
              shipmentCharge :   calculateTotalShipment((distributorOptionsInNOSection?.[0]?.noDistributor ?  distributorOptionsInNOSection?.[0]?.initial_gpl_price : distributorOptionsInNOSection?.[0]?.initial_price), distributorOptionsInNOSection?.[0]?.logistics?.logistic_fee, distributorOptionsInNOSection?.[0]?.logistics?.custom_fee, distributorOptionsInNOSection?.[0]?.logistics?.logistic_buffer_charge),
          }));
        break
      default:
        console.error("No section available");
        break;
        
    }
  }
  // ----------Terms & condition END--------

  useEffect(() => {
     /**
     * Scroll functionality.
     */
    if (modalContentRef.current) {
      modalContentRef.current.style.maxHeight = "850px";
      modalContentRef.current.style.overflow = "scroll";
    }
    if(!modal){
      setNoSectionFormInputErrorMessage({})
    }
  }, [modal]);

  useEffect(()=>{
    if(isEditQuotation){
      setSearchInput(null)
    }
    if(isSectionActive){
      setDistributorOptionDropdownIsOpen(false)
    }else{
      setDistributorOptionDropdownIsOpen(false)
    }
  },[isSectionActive])


  const noSectionTotalProductFinalPrice =  useMemo(()=>{
  let totalPrice = 0;
    function addPrice(price) {
      const numericPrice = parseFloat(price);
      if (!isNaN(numericPrice)) {
        totalPrice += numericPrice;
      }
    }
    notSectionBaseSavedProduct?.forEach(product => {
      addPrice(product.markup_total_price);
      // Add markup_total_price for supported products
      if (product.supportedProducts && product.supportedProducts?.[product.product.productCode]) {

        
        product.supportedProducts?.[product.product.productCode].forEach(supportedProduct => {

          if(isEditQuotation && supportedProduct.checked){
            if(supportedProduct?.markup_total_price){
                addPrice(supportedProduct.markup_total_price);
              return
            }
            /*
             * Initial time the below case will work in case of edit 
             * if we are adding new product in case of edit above case will work 
             */
            const gplPrice = supportedProduct?.gpl_price || null;
            const withoutMarkupPrice =  supportedProduct?.distributor?.price || null;
            const markupTotalPrice = supportedProduct.pricing_policy == pricingPolicy.manufacture_discount.value ?
            // Case 3 Manufacture Discount                                                                                              // quantity
            (parseFloat((parseFloat(( gplPrice  || withoutMarkupPrice)) * (1 - parseFloat((supportedProduct.standard_markup  || 0) ) / 100)).toFixed(2)) * parseFloat(supportedProduct.quantity)).toFixed(2) :

            (parseFloat((parseFloat(( gplPrice || withoutMarkupPrice )) * (1 + parseFloat((supportedProduct.standard_markup  || 0) ) / 100)).toFixed(2)) * parseFloat(supportedProduct.quantity)).toFixed(2)
            
            addPrice(markupTotalPrice);
          }else if(supportedProduct.checked){
            // Checked product only
            addPrice(supportedProduct.markup_total_price);
          }
        });
      }
    });
    return totalPrice.toFixed(2)
  },[notSectionBaseSavedProduct])

  const sectionTotalProductFinalPrice = useMemo(() => {
    const totalPrice = {};
  
    // Function to add price to the appropriate section
    function addPrice(price, sectionIndex, section) {
      const numericPrice = parseFloat(price);
      if (isNaN(numericPrice)) return; // Skip invalid prices
  
      switch (section) {
        case 'MAIN_SECTION':
          // Add or update finalPrice for the main section
          totalPrice[sectionIndex] = {
            ...totalPrice[sectionIndex],
            finalPrice: (totalPrice?.[sectionIndex]?.finalPrice || 0) + numericPrice,
          };
          break;
  
        case 'SUB_SECTION':
          const { sectionKey, subSectionKey } = sectionIndex;
          // Ensure subSection is created and properly updated
          totalPrice[sectionKey] = {
            ...totalPrice[sectionKey],
            subSection: {
              ...totalPrice[sectionKey]?.subSection,
              [subSectionKey]: {
                finalPrice: (totalPrice?.[sectionKey]?.subSection?.[subSectionKey]?.finalPrice || 0) + numericPrice,
              },
            },
          };
          break;
        default:
          console.log('UNKNOWN SECTION');
          break
          
      }
    }
  
    // Iterate through sections and calculate prices
    for (const sectionKey in sectionBaseSavedProducts) {
      const section = sectionBaseSavedProducts[sectionKey];
  
      // Handle main products
      if (section.products) {
        section.products.forEach(product => {
          addPrice(product.markup_total_price, sectionKey, 'MAIN_SECTION');
  
          // Handle supported products
          if (product.supportedProducts) {
            product.supportedProducts.forEach(supportedProduct => {
              if (supportedProduct.checked) {
                addPrice(supportedProduct.markup_total_price, sectionKey, 'MAIN_SECTION');
              }
            });
          }
        });
      }
  
      // Handle subsections (uncomment if needed)
      if (section.subSections) {
        for (const subSectionKey in section.subSections) {
          const subSection = section.subSections[subSectionKey];
          if (Array.isArray(subSection)) {
            subSection.forEach(subProduct => {
              addPrice(subProduct.markup_total_price, { sectionKey, subSectionKey }, 'SUB_SECTION');
  
              // Handle supported products in subsections
              if (subProduct.supportedProducts) {
                subProduct.supportedProducts.forEach(supportedProduct => {
                  if (supportedProduct.checked) {
                    addPrice(supportedProduct.markup_total_price, { sectionKey, subSectionKey }, 'SUB_SECTION');
                  }
                });
              }
            });
          }
        }
      }
    }
  
    return totalPrice;
  }, [sectionBaseSavedProducts]);
  


  // Function handle open & close modal
  const handleShowViewModal = (sectionIndex, section) => {
    let obj ={
      sectionIndex,
      section
    }
    
    setViewPopUpSection(obj)
    setViewModal(!viewModal);
    if (viewModal) {
      // # Reset 
      setViewPopUpSection({})
    }
  };

  //<---------------------SECTION HANDLING--------------------> 
    const addSection = () => {
      const trimmedName = sectionName.trim();
      if (!trimmedName) return;
      if (sectionItems?.some((item) => item.name === trimmedName)) {
        setErrorMessage(`Section name "${trimmedName}" already exists`);
        return;
      }
      setSectionItems((prev) => [
        ...prev,
        { name: trimmedName, subSections: [] },
      ]);
      setSectionName("");
      setErrorMessage("");
    };
    const addSubSection = (sectionIndex) => {
      const subName = subSectionNames[sectionIndex]?.trim();
      if (!subName) return;

      for (let item of sectionItems[sectionIndex]?.subSections) {
        if (item.name == subName) {
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx === sectionIndex
                ? {
                    ...section,
                    errorMessage: `Sub Section name "${subName}" already exists`,
                  }
                : section
            )
          );
          // setSubAccordionErrorMessage(`Sub Section name "${subName}" already exists`);
          return;
        }
      }

      setSectionItems((prev) =>
        prev.map((section, idx) =>
          idx === sectionIndex
            ? {
                ...section,
                subSections: [...section.subSections, { name: subName }],
                errorMessage: "",
              }
            : section
        )
      );
      setSubSectionNames((prev) => ({ ...prev, [sectionIndex]: "" }));
    };
  //<---------------------SECTION HANDLING END-----------------> 

  //<--------------------ONCHANGE FUNCTIONALITY----------------------------->
    const handleCustomerSelectChange = (selected) => {
      setSelectedCustomer(selected);
    };
    const handleSalesSelectChange = (selected) => {
      setSelectedSales(selected);
    };


    
    const handleProductSelectChange = useCallback(
      (selected, sectionIndex, section) => {
        if(selected.data?.isCertificateExpired){
            toast.error('This product’s Saber certificate has expired. Please renew to ensure compliance.')
            // return
        }
        let distributorOptions  = []
        let distributorList = null;
        console.log("selected--->", selected);
        
        if(selected.data?.distributors?.length != 0){
          distributorList = selected.data?.distributors
            distributorOptions =  selected.data?.distributors?.map((item)=>({label : (
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 8px" }}>
                <span style={{ fontWeight: "500" }}>{item.name}</span>  
                <button
                  type="button"
                  style={{
                    padding: "4px 8px",
                    border: "none",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    borderRadius: "12px",
                    fontSize: "0.85em",
                    cursor: "pointer",
                  }}
                >
                  {item?.currency} {item.initial_price}
                </button>
              </div>
            ) , name: item.name, lead_time : item.lead_time,  currency : item.currency,initial_price : item.initial_price,  value : item.id,price : item.price, markup_price : item.markup_price , noDistributor : false,
            logistics : {
              custom_fee : selected.data.custom_fee,
              logistic_fee : selected.data.logistic_fee,
              logistic_buffer_charge : selected.data.logistic_buffer_charge
            }
           }))
        }else{
          distributorOptions.push({ value: '', label: 'No Distributor' , initial_gpl_price :  selected.data.initial_gpl_price, gpl_price : selected.data.gpl_price, noDistributor : true}) 
        }

        
        let logisticsCharge = selected.data.logistic_fee;
        let customCharge = selected.data.custom_fee;
        let bufferCharge  = selected.data.logistic_buffer_charge;
        if (logisticsCharge <= 0) {
          logisticsCharge = 0;
        }
        if (customCharge <= 0) {
          customCharge = 0;
        }
        if (bufferCharge <= 0) {
          bufferCharge = 0;
        }
        const  selectedSortOption = 'PRICE';
        const basePrice  =  distributorOptions?.[0].gpl_price || distributorOptions?.[0].price || 0
        const initialBasePrice = distributorOptions?.[0].initial_gpl_price || distributorOptions?.[0].initial_price || 0
        const shipmentCharge =    calculateTotalShipment(initialBasePrice, logisticsCharge, customCharge, bufferCharge);

        
        const markupFee = calculatePrice('MARKUP_FEE', pricingPolicy.standard_pricing.value, basePrice,appStandardMarkup,'')

        

        switch (section) {
          case "MAIN_SECTION":
            setSectionItems((prev) =>
              prev.map((section, idx) =>
                idx === sectionIndex
                  ? {
      
                    
                      ...section,
                      product: selected,
                      standard_markup : parseFloat(appStandardMarkup).toString() || '0',
                      manufacture : selected.data?.manufacturer,
                      quantity : 1,
                      distributor : distributorOptions?.[0] || {}, // Default selection
                      distributors : selected.data?.distributors,
                      distributorOptions :  distributorOptions,
                      isCertificateExpired : selected.data.isCertificateExpired,
                      part_number : selected.data.part_number,
                      // distributor_price_with_markup :distributorOptions?.[0]?.markup_price ||  (parseFloat(distributorOptions?.[0].gpl_price || 0) * (1 + parseFloat(appStandardMarkup || 0) / 100)).toFixed(2),
                      unit_type : 'Ea',
                      initial_gpl_price : selected.data?.initial_gpl_price,
                      noDistributor : distributorOptions?.[0]?.noDistributor,
                      gpl_price : distributorOptions?.[0].gpl_price, // (included logistic fee + markup)
                      shipmentCharge :shipmentCharge,
                      markupFee : markupFee, 

                      isChildProductsAvailable : selected.data?.isChildProductsAvailable,
                      distributorList : distributorList,
                      selectedSortOption : selectedSortOption,
                      pricingPolicyOption : pricingPolicy.standard_pricing.value,
                      pricing_policy_discount: {type : pricingPolicy.standard_pricing.value, value : '0'},
                      distributor_price_with_markup : calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', pricingPolicy.standard_pricing.value, (distributorOptions?.[0].gpl_price || distributorOptions?.[0].price) , appStandardMarkup,''),
                      markup_total_price :  calculatePrice('MARKUP_TOTAL_PRICE', pricingPolicy.standard_pricing.value, (distributorOptions?.[0].gpl_price || distributorOptions?.[0].price) ,appStandardMarkup,1),
                      // markup_total_price : distributorOptions?.[0]
                      // ? (
                      //     parseFloat(
                      //       distributorOptions?.[0].gpl_price || distributorOptions?.[0].price || 0
                      //     ) *
                      //     (1 + parseFloat(appStandardMarkup) / 100)
                      //   ).toFixed(2)
                      // : '0'
                    }
                  : section
              )
            );
            break;
          case "SUB_SECTION":
            const { index, subIdx } = sectionIndex;
            setSectionItems((prev) =>
              prev.map((section, idx) =>
                idx === index
                  ? {
                      ...section,
                      subSections: section.subSections?.map(
                        (subSecItem, subSecIdx) =>
                          subSecIdx == subIdx
                            ? {
                                ...subSecItem,
                                product: selected,
                                markup_total_price :0,
                                standard_markup : parseFloat(appStandardMarkup).toString() || '0',
                                manufacture : selected.data?.manufacturer,
                                quantity : 1,
                                distributor : distributorOptions?.[0] || {},
                                distributors : selected.data?.distributors, // Default selection
                                unit_type : 'Ea',
                                // distributor_price_with_markup :distributorOptions?.[0]?.markup_price ||  (parseFloat(distributorOptions?.[0].gpl_price || 0) * (1 + parseFloat(appStandardMarkup || 0) / 100)).toFixed(2),

                                initial_gpl_price : selected.data?.initial_gpl_price,
                                noDistributor : distributorOptions?.[0]?.noDistributor,
                                gpl_price : distributorOptions?.[0].gpl_price, // (included logistic fee + markup)
                                shipmentCharge :shipmentCharge,
                                markupFee : markupFee, 

                                isCertificateExpired : selected.data.isCertificateExpired,
                                part_number : selected.data.part_number,
                                distributorList : distributorList,
                                selectedSortOption : selectedSortOption,
                                isChildProductsAvailable : selected.data?.isChildProductsAvailable,
                                pricingPolicyOption : pricingPolicy.standard_pricing.value,
                                pricing_policy_discount: {type : pricingPolicy.standard_pricing.value, value : '0'},
                                distributorOptions :  distributorOptions,
                                distributor_price_with_markup : calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', pricingPolicy.standard_pricing.value, (distributorOptions?.[0].gpl_price || distributorOptions?.[0].price) , appStandardMarkup,''),
                                markup_total_price :  calculatePrice('MARKUP_TOTAL_PRICE', pricingPolicy.standard_pricing.value, (distributorOptions?.[0].gpl_price || distributorOptions?.[0].price) ,appStandardMarkup,1),
                                // markup_total_price : distributorOptions?.[0]
                                // ? (
                                //     parseFloat(
                                //       distributorOptions?.[0].gpl_price || distributorOptions?.[0].price || 0
                                //     ) *
                                //     (1 + parseFloat(appStandardMarkup) / 100)
                                //   ).toFixed(2)
                                // : '0'
                                // ,
                              }
                            : subSecItem
                      ),
                    }
                  : section
              )
            );
            break;
          case 'NO_SECTION':

            
            setSelectedProduct(
              (prev)=>({
                  ...prev,
                  label : selected.label,
                  productCode : selected.productCode,
                  productId : selected.productId,
                  value: selected.value,
                  part_number : selected.data.part_number,
                  manufacture : selected.data?.manufacturer,
                  isCertificateExpired : selected.data.isCertificateExpired,
                  product: selected,
                  distributorOptions: distributorOptions,
                  standard_markup: parseFloat(appStandardMarkup).toString() || "0",
                  quantity: 1,
                  
                  unit_type : "Ea",
                  isChildProductsAvailable : selected.data?.isChildProductsAvailable,
                  distributorList : distributorList,
                  selectedSortOption : selectedSortOption,
                  distributor: distributorOptions?.[0] || {}, // Default selection
                 
                  // distributor_price_with_markup :distributorOptions?.[0]?.markup_price || (parseFloat(distributorOptions?.[0].gpl_price || 0) * (1 + parseFloat(appStandardMarkup || 0) / 100)).toFixed(2),
                  initial_gpl_price : selected.data?.initial_gpl_price,
                  noDistributor : distributorOptions?.[0]?.noDistributor,
                  gpl_price : distributorOptions?.[0].gpl_price, // (included logistic fee + markup)
                  shipmentCharge :shipmentCharge,
                  markupFee : markupFee, 
                  pricingPolicyOption : pricingPolicy.standard_pricing.value,
                  pricing_policy_discount: {type : pricingPolicy.standard_pricing.value, value : '0'},
                  distributor_price_with_markup : calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', pricingPolicy.standard_pricing.value, (distributorOptions?.[0].gpl_price || distributorOptions?.[0].price) , appStandardMarkup,''),
                  markup_total_price :  calculatePrice('MARKUP_TOTAL_PRICE', pricingPolicy.standard_pricing.value, (distributorOptions?.[0].gpl_price || distributorOptions?.[0].price) ,appStandardMarkup,1)
                  // markup_total_price : distributorOptions?.[0]
                  // ? (
                  //     parseFloat(
                  //       distributorOptions?.[0].gpl_price || distributorOptions?.[0].price || 0
                  //     ) *
                  //     (1 + parseFloat(appStandardMarkup) / 100)
                  //   ).toFixed(2)
                  // : '0'
                  // ,
              })
              // {
              //   ...selected,
              //   // product: selected,
                
              // }
          );
            
            break
          default:
             console.log("UnKnown section");
            break;
        }
      },
      [appStandardMarkup]
    );
    console.log("sectionItem", sectionItems);
    const handleDistributorSelectChange = useCallback(
      (selected, sectionIndex, section) => {
        console.log("selected->", selected);

        
        switch (section) {
          case "MAIN_SECTION":

            
            setSectionItems((prev) =>
              prev.map((section, idx) =>
                idx === sectionIndex
                  ? {
                      ...section,
                      distributor: selected,
                      quantity : section.quantity,
                      standard_markup : parseFloat(section.standard_markup || 0).toString() || '0',
                      shipmentCharge :   calculateTotalShipment((selected.noDistributor ?  selected.initial_gpl_price : selected.initial_price), section.product.data.logistic_fee, section.product.data.custom_fee, section.product.data.logistic_buffer_charge),
                      // Price with markup=P+(P×M)
                      distributor_price_with_markup : section.pricingPolicyOption == pricingPolicy.manufacture_discount.value ?
                      // Case 3 Manufacture Discount 
                      (parseFloat((selected?.gpl_price || selected?.price)) * (1 - parseFloat((section.standard_markup || 0)) / 100)).toFixed(2)
                      :
                      (parseFloat((selected?.gpl_price || selected?.price)) * (1 + parseFloat((section.standard_markup || 0)) / 100)).toFixed(2),
                      markupFee : calculatePrice('MARKUP_FEE', section.pricingPolicyOption, (selected?.gpl_price || selected?.price), section.standard_markup,''),
                      markup_total_price : 
                      section.pricingPolicyOption == pricingPolicy.manufacture_discount.value ?
                          // Case 3 Manufacture Discount 
                          (parseFloat((parseFloat(( selected?.gpl_price || selected?.price)) * (1 - parseFloat((section.standard_markup || 0) ) / 100)).toFixed(2)) * parseFloat(section.quantity|| 0)).toFixed(2) :
                          (parseFloat((parseFloat(( selected?.gpl_price || selected?.price)) * (1 + parseFloat((section.standard_markup || 0) ) / 100)).toFixed(2)) * parseFloat(section.quantity || 0)).toFixed(2),
                    }
                  : section
              )
            );
            break;
          case "SUB_SECTION":
            const { index, subIdx } = sectionIndex;
            setSectionItems((prev) =>
              prev.map((section, idx) =>
                idx === index
                  ? {
                      ...section,
                      subSections: section.subSections?.map(
                        (subSecItem, subSecIdx) =>
                          subSecIdx == subIdx
                            ? {
                                ...subSecItem,
                                distributor: selected,
                                quantity : subSecItem.quantity,
                                standard_markup : parseFloat(subSecItem.standard_markup) || '0',
                                shipmentCharge :   calculateTotalShipment((selected.noDistributor ?  selected.initial_gpl_price : selected.initial_price), subSecItem.product.data.logistic_fee, subSecItem.product.data.custom_fee, subSecItem.product.data.logistic_buffer_charge),
                                distributor_price_with_markup : subSecItem.pricingPolicyOption == pricingPolicy.manufacture_discount.value ?
                                // Case 3 Manufacture Discount 
                                (parseFloat((selected?.gpl_price || selected?.price)) * (1 - parseFloat((subSecItem.standard_markup || 0)) / 100)).toFixed(2)
                                :
                                (parseFloat((selected?.gpl_price || selected?.price)) * (1 + parseFloat((subSecItem.standard_markup || 0)) / 100)).toFixed(2),
                                markupFee : calculatePrice('MARKUP_FEE', subSecItem.pricingPolicyOption, (selected?.gpl_price || selected?.price), subSecItem.standard_markup,''),
                                markup_total_price : 
                                subSecItem.pricingPolicyOption == pricingPolicy.manufacture_discount.value ?
                                    // Case 3 Manufacture Discount 
                                    (parseFloat((parseFloat(( selected?.gpl_price || selected?.price)) * (1 - parseFloat((subSecItem.standard_markup || 0) ) / 100)).toFixed(2)) * parseFloat(subSecItem.quantity|| 0)).toFixed(2) :
                                    (parseFloat((parseFloat(( selected?.gpl_price || selected?.price)) * (1 + parseFloat((subSecItem.standard_markup || 0) ) / 100)).toFixed(2)) * parseFloat(subSecItem.quantity || 0)).toFixed(2),
                
                                


                              }
                            : subSecItem
                      ),
                    }
                  : section
              )
            );
            break;
          case 'NO_SECTION' :
            setSelectedProduct((prev)=>(
              {
                ...prev,
                distributor: selected,
                quantity: prev.quantity, // Setting the quantity
                standard_markup: parseFloat(prev.standard_markup) || "0",
                shipmentCharge :   calculateTotalShipment((selected.noDistributor ?  selected.initial_gpl_price : selected.initial_price), prev.product.data.logistic_fee, prev.product.data.custom_fee, prev.product.data.logistic_buffer_charge),
                distributor_price_with_markup : prev.pricingPolicyOption == pricingPolicy.manufacture_discount.value ?
                // Case 3 Manufacture Discount 
                (parseFloat((selected?.gpl_price || selected?.price)) * (1 - parseFloat((prev.standard_markup || 0)) / 100)).toFixed(2)
                :
                (parseFloat((selected?.gpl_price || selected?.price)) * (1 + parseFloat((prev.standard_markup || 0)) / 100)).toFixed(2),
                markupFee : calculatePrice('MARKUP_FEE', prev.pricingPolicyOption, (selected?.gpl_price || selected?.price), prev.standard_markup,''),
                markup_total_price : 
                prev.pricingPolicyOption == pricingPolicy.manufacture_discount.value ?
                    // Case 3 Manufacture Discount 
                    (parseFloat((parseFloat(( selected?.gpl_price || selected?.price)) * (1 - parseFloat((prev.standard_markup || 0) ) / 100)).toFixed(2)) * parseFloat( prev.quantity|| 0)).toFixed(2) :
                    (parseFloat((parseFloat(( selected?.gpl_price || selected?.price)) * (1 + parseFloat((prev.standard_markup || 0) ) / 100)).toFixed(2)) * parseFloat( prev.quantity || 0)).toFixed(2),
            


              }))
            break;
          default:
          console.log("Unknown section");
            break;
        }
      },
      [appStandardMarkup,selectedProduct]
    );

    const handleStandardMarkupChange = (value, sectionIndex, section)=>{

        // if(isNaN(value)){
        //   value = '0'
        // }

        switch (section) {
          case "MAIN_SECTION":
            setSectionItems((prev) =>
              prev.map((section, idx) =>
                idx == sectionIndex
                  ? {
                      ...section,
                      standard_markup: value.trim(),

                      distributor_price_with_markup : section.pricingPolicyOption == pricingPolicy.manufacture_discount.value ?
                      // Case 3 Manufacture Discount 
                      (parseFloat((section?.distributor?.gpl_price || section?.distributor?.price)) * (1 - parseFloat((value || 0)) / 100)).toFixed(2)
                      :
                      (parseFloat((section?.distributor?.gpl_price || section?.distributor?.price)) * (1 + parseFloat((value || 0)) / 100)).toFixed(2),
                      markupFee : (
                        parseFloat(section?.distributor?.gpl_price || section?.distributor?.price) * 
                        (parseFloat(value ||  0) / 100)
                      ).toFixed(2),
                      markup_total_price : 
                      section.pricingPolicyOption == pricingPolicy.manufacture_discount.value ?
                        // Case 3 Manufacture Discount 
                        (parseFloat((parseFloat(( section?.distributor?.gpl_price || section?.distributor?.price)) * (1 - parseFloat((value || 0) ) / 100)).toFixed(2)) * parseFloat(section?.quantity || 0)).toFixed(2) :

                        (parseFloat((parseFloat(( section?.distributor?.gpl_price || section?.distributor?.price)) * (1 + parseFloat((value || 0) ) / 100)).toFixed(2)) * parseFloat(section?.quantity || 0)).toFixed(2)
                    }
                  : section
              )
            );
            break;
          case "SUB_SECTION":
            const { index, subIdx } = sectionIndex;
            setSectionItems((prev) =>
              prev.map((section, idx) =>
                idx === index
                  ? {
                      ...section,
                      subSections: section.subSections?.map(
                        (subSecItem, subSecIdx) =>
                          subSecIdx == subIdx
                            ? {
                                ...subSecItem,
                                standard_markup: value.trim(),


                                distributor_price_with_markup : subSecItem.pricingPolicyOption == pricingPolicy.manufacture_discount.value ?
                                // Case 3 Manufacture Discount 
                                (parseFloat((subSecItem?.distributor?.gpl_price || subSecItem?.distributor?.price)) * (1 - parseFloat((value || 0)) / 100)).toFixed(2)
                                :
                                (parseFloat((subSecItem?.distributor?.gpl_price || subSecItem?.distributor?.price)) * (1 + parseFloat((value || 0)) / 100)).toFixed(2),
                                markupFee : (
                                  parseFloat(subSecItem?.distributor?.gpl_price || subSecItem?.distributor?.price) * 
                                  ((parseFloat(value || 0)) / 100)
                                ).toFixed(2),
                                markup_total_price : 
                                subSecItem.pricingPolicyOption == pricingPolicy.manufacture_discount.value ?
                                  // Case 3 Manufacture Discount 
                                  (parseFloat((parseFloat(( subSecItem?.distributor?.gpl_price || subSecItem?.distributor?.price)) * (1 - parseFloat((value || 0) ) / 100)).toFixed(2)) * parseFloat(subSecItem?.quantity || 0)).toFixed(2) :

                                  (parseFloat((parseFloat(( subSecItem?.distributor?.gpl_price || subSecItem?.distributor?.price)) * (1 + parseFloat((value || 0) ) / 100)).toFixed(2)) * parseFloat(subSecItem?.quantity || 0)).toFixed(2)
                              }
                            : subSecItem
                      ),
                    }
                  : section
              )
            );
            break;
          case 'NO_SECTION':
            setSelectedProduct((prev)=>
            (
              {
                ...prev,
                standard_markup: value.trim(),

                distributor_price_with_markup : prev.pricingPolicyOption == pricingPolicy.manufacture_discount.value ?
                // Case 3 Manufacture Discount 
                (parseFloat((selectedProduct?.distributor?.gpl_price || selectedProduct?.distributor?.price)) * (1 - parseFloat((value || 0)) / 100)).toFixed(2)
                :
                (parseFloat((selectedProduct?.distributor?.gpl_price || selectedProduct?.distributor?.price)) * (1 + parseFloat((value || 0)) / 100)).toFixed(2),
                markupFee :(
                      parseFloat(
                        selectedProduct?.distributor?.gpl_price || selectedProduct?.distributor?.price || 0) * 
                      ((parseFloat(value || 0)) / 100)
                  ).toFixed(2),
                markup_total_price : 
                prev.pricingPolicyOption == pricingPolicy.manufacture_discount.value ?
                    // Case 3 Manufacture Discount 
                    (parseFloat((parseFloat(( selectedProduct?.distributor?.gpl_price || selectedProduct?.distributor?.price)) * (1 - parseFloat((value || 0) ) / 100)).toFixed(2)) * parseFloat(selectedProduct?.quantity || 0)).toFixed(2) :

                    (parseFloat((parseFloat(( selectedProduct?.distributor?.gpl_price || selectedProduct?.distributor?.price)) * (1 + parseFloat((value || 0) ) / 100)).toFixed(2)) * parseFloat(selectedProduct?.quantity || 0)).toFixed(2)
              }
            ))
            break;
          default:
            console.log("Unknown section");
            break;
        }
    }

    const handleQuantityChange = useCallback((pricingPolicyOption,value, sectionIndex, section) => {
      const trimmedValue = value.toString().trim();
      const parsedQuantity = parseFloat(trimmedValue) || 0; 
      switch (section) {
        case "MAIN_SECTION":
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx == sectionIndex
                ? {
                    ...section,
                    quantity: value.trim(),
                    markup_total_price : (parseFloat( section.distributor_price_with_markup) * (parsedQuantity || 0)).toFixed(2)

        
                  }
                : section
            )
          );
          break;
        case "SUB_SECTION":
          const { index, subIdx } = sectionIndex;
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx === index
                ? {
                    ...section,
                    subSections: section.subSections?.map(
                      (subSecItem, subSecIdx) =>
                        subSecIdx == subIdx
                          ? {
                              ...subSecItem,
                              quantity: value.trim(),
                              markup_total_price : (parseFloat( subSecItem.distributor_price_with_markup ) * (parsedQuantity || 0)).toFixed(2)

                            }
                          : subSecItem
                    ),
                  }
                : section
            )
          );
          break;
        case 'NO_SECTION':
          setSelectedProduct((prev)=>(
            {
              ...prev,
              quantity: trimmedValue,
              markup_total_price : (parseFloat( prev.distributor_price_with_markup ) * (parsedQuantity || 0)).toFixed(2)
            }
          ))
          break;
        default:
          console.log("Unknown section");
          break;
      }
    }, [selectedProduct]);

    const handleUnitTypeChange = useCallback((value, sectionIndex, section) => {

      switch (section) {
        case "MAIN_SECTION":
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx == sectionIndex
                ? {
                    ...section,
                    unit_type: value,
                  }
                : section
            )
          );
          break;
        case "SUB_SECTION":
          const { index, subIdx } = sectionIndex;
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx === index
                ? {
                    ...section,
                    subSections: section.subSections?.map(
                      (subSecItem, subSecIdx) =>
                        subSecIdx == subIdx
                          ? {
                              ...subSecItem,
                              unit_type: value.trim(),
                            }
                          : subSecItem
                    ),
                  }
                : section
            )
          );
          break;
        case 'NO_SECTION':
          setSelectedProduct((prev)=>(
            {
              ...prev,
              unit_type: value
            }))
        default:
          console.log("Unknown section");
          break;
      }
    }, [selectedProduct]);

    const handleTotalPriceChange = useCallback((value, sectionIndex, section) => {
      const trimmedValue = value.toString().trim();
      switch (section) {
        case "MAIN_SECTION":
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx == sectionIndex
                ? {
                    ...section,
                    markup_total_price: trimmedValue,
                  }
                : section
            )
          );
          break;
        case "SUB_SECTION":
          const { index, subIdx } = sectionIndex;
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx === index
                ? {
                    ...section,
                    subSections: section.subSections?.map(
                      (subSecItem, subSecIdx) =>
                        subSecIdx == subIdx
                          ? {
                              ...subSecItem,
                              markup_total_price: trimmedValue
                            }
                          : subSecItem
                    ),
                  }
                : section
            )
          );
          break;
        case 'NO_SECTION':
          setSelectedProduct((prev)=>(
            {
              ...prev,
              markup_total_price: trimmedValue
            }))
        default:
          console.log("Unknown section");
          break;
      }
    }, [selectedProduct]);

    const handleDistributorPriceChange = useCallback((value, sectionIndex, section) => {
      const trimmedValue = value.toString().trim();
      switch (section) {
        case "MAIN_SECTION":
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx == sectionIndex
                ? {
                    ...section,
                    distributor_price_with_markup: trimmedValue,
                    markup_total_price : trimmedValue * section.quantity,
                    standard_markup : '0',
                    markupFee : '0'
                  }
                : section
            )
          );
          break;
        case "SUB_SECTION":
          const { index, subIdx } = sectionIndex;
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx === index
                ? {
                    ...section,
                    subSections: section.subSections?.map(
                      (subSecItem, subSecIdx) =>
                        subSecIdx == subIdx
                          ? {
                              ...subSecItem,
                              distributor_price_with_markup: trimmedValue,
                              markup_total_price : trimmedValue * subSecItem.quantity,
                              standard_markup : '0',
                              markupFee : '0'
                
                            }
                          : subSecItem
                    ),
                  }
                : section
            )
          );
          break;
        case 'NO_SECTION':
          setSelectedProduct((prev)=>(
            {
              ...prev,
              distributor_price_with_markup: trimmedValue,
              markup_total_price : trimmedValue * prev.quantity,
              standard_markup : '0',
              markupFee : '0'
             
            }))
        default:
          console.log("Unknown section");
          break;
      }
    }, [selectedProduct]);

    const handlePricePolicyChange = useCallback((value, sectionIndex, section) => {      

      switch (section) {
        case "MAIN_SECTION":
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx == sectionIndex
                ? {
                    ...section,
                    pricingPolicyOption: value,
                    pricing_policy_discount: {type : value, value : '0'}, // Default setup
                    markupFee : value == pricingPolicy.manufacture_discount.value ? '0.00' :  (
                      parseFloat(section.distributor.gpl_price   || section.distributor.price) * 
                      ((parseFloat(section.standard_markup || 0)) / 100)
                  ).toFixed(2),
                    distributor_price_with_markup : value == pricingPolicy.manufacture_discount.value ? 
                    // Case-3 Manufacture discount 
                    (parseFloat(section.distributor.gpl_price   || section.distributor.price) - parseFloat(section.distributor.gpl_price   || section.distributor.price) * (parseFloat(section.standard_markup || 0) / 100)).toFixed(2) :
                    ( parseFloat(section.distributor.gpl_price   || section.distributor.price) + parseFloat(section.distributor.gpl_price   || section.distributor.price) * (parseFloat(section.standard_markup || 0) / 100)).toFixed(2),
                    markup_total_price : 
                      value == pricingPolicy.manufacture_discount.value ?
                          (parseFloat(
                            section.distributor.gpl_price || section.distributor.price || 0
                          ) *
                            (1 - parseFloat(section.standard_markup || 0) / 100)
                            * (section.quantity || 0)
                          ).toFixed(2) 
                          :
                          (parseFloat(
                            section.distributor.gpl_price || section.distributor.price || 0
                          ) *
                            (1 + parseFloat(section.standard_markup || 0) / 100)
                            * (section.quantity || 0)
                          ).toFixed(2) 
                          }
                        : section
            )
          );
          break;
        case "SUB_SECTION":
          const { index, subIdx } = sectionIndex;
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx === index
                ? {
                    ...section,
                    subSections: section.subSections?.map(
                      (subSecItem, subSecIdx) =>
                        subSecIdx == subIdx
                          ? {
                              ...subSecItem,
                              pricingPolicyOption: value,
                              pricing_policy_discount: {type : value, value : '0'}, // Default setup
                              markupFee : value == pricingPolicy.manufacture_discount.value ? '0.00' : (
                                parseFloat(subSecItem.distributor.gpl_price   || subSecItem.distributor.price) * 
                                ((parseFloat(subSecItem.standard_markup || 0)) / 100)
                            ).toFixed(2),
                              distributor_price_with_markup : value == pricingPolicy.manufacture_discount.value ? 
                              // Case-3 Manufacture discount 
                              (parseFloat( subSecItem.distributor.gpl_price  || subSecItem.distributor.price) - parseFloat(subSecItem.distributor.gpl_price  || subSecItem.distributor.price) * (parseFloat(subSecItem.standard_markup || 0) / 100)).toFixed(2) :
                              ( parseFloat(subSecItem.distributor.gpl_price  || subSecItem.distributor.price) + parseFloat(subSecItem.distributor.gpl_price  || subSecItem.distributor.price) * (parseFloat(subSecItem.standard_markup || 0) / 100)).toFixed(2),
                              markup_total_price : 
                                    value == pricingPolicy.manufacture_discount.value ?
                                        (parseFloat(
                                          subSecItem.distributor.gpl_price || subSecItem.distributor.price || 0
                                        ) *
                                          (1 - parseFloat(subSecItem.standard_markup || 0) / 100)
                                          * (subSecItem.quantity || 0)
                                        ).toFixed(2) 
                                        :
                                        (parseFloat(
                                          subSecItem.distributor.gpl_price || subSecItem.distributor.price || 0
                                        ) *
                                          (1 + parseFloat(subSecItem.standard_markup || 0) / 100)
                                          * (subSecItem.quantity || 0)
                                        ).toFixed(2) 
                            }
                          : subSecItem
                    ),
                  }
                : section
            )
          );
          break;
        case 'NO_SECTION':
          setSelectedProduct((prev)=>(
            {
              ...prev,
              pricingPolicyOption: value,
              pricing_policy_discount: {type : value, value : '0'}, // Default setup
              markupFee : value == pricingPolicy.manufacture_discount.value ? '0.00' : (
                parseFloat(prev.distributor.gpl_price   || prev.distributor.price) * 
                ((parseFloat(prev.standard_markup || 0)) / 100)
            ).toFixed(2),
              distributor_price_with_markup : value == pricingPolicy.manufacture_discount.value ? 
              // Case-3 Manufacture discount 
              (parseFloat(prev.distributor.gpl_price || prev.distributor.price) - parseFloat(prev.distributor.gpl_price || prev.distributor.price) * (parseFloat(prev.standard_markup || 0) / 100)).toFixed(2) :
              ( parseFloat(prev.distributor.gpl_price || prev.distributor.price) + parseFloat(prev.distributor.gpl_price || prev.distributor.price) * (parseFloat(prev.standard_markup || 0) / 100)).toFixed(2),
              markup_total_price : 
              value == pricingPolicy.manufacture_discount.value ?
                  (parseFloat(
                    prev.distributor.gpl_price || prev.distributor.price || 0
                  ) *
                    (1 - parseFloat(prev.standard_markup || 0) / 100)
                    * (prev.quantity || 0)
                  ).toFixed(2) 
                  :
                  (parseFloat(
                    prev.distributor.gpl_price || prev.distributor.price || 0
                  ) *
                    (1 + parseFloat(prev.standard_markup || 0) / 100)
                    * (prev.quantity || 0)
                  ).toFixed(2) 
              
              
            }))
        default:
          console.log("Unknown section");
          break;
      }
    }, [selectedProduct]);

    const handlePricingPolicyDiscountChange = useCallback((pricingPolicyOption, value, sectionIndex, section) => {

      const trimmedValue = value.toString().trim();
      const parsedDiscount = parseFloat(trimmedValue) || 0; 
      switch (section) {
        case "MAIN_SECTION":
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx == sectionIndex
                ? {
                    ...section,
                    pricing_policy_discount: {type : pricingPolicyOption, value : parsedDiscount},
                    
                  }
                : section
            )
          );
          break;
        case "SUB_SECTION":
          const { index, subIdx } = sectionIndex;
          setSectionItems((prev) =>
            prev.map((section, idx) =>
              idx === index
                ? {
                    ...section,
                    subSections: section.subSections?.map(
                      (subSecItem, subSecIdx) =>
                        subSecIdx == subIdx
                          ? {
                              ...subSecItem,
                              pricing_policy_discount: {type : pricingPolicyOption, value : parsedDiscount},
                            }
                          : subSecItem
                    ),
                  }
                : section
            )
          );
          break;
        case 'NO_SECTION':
          setSelectedProduct((prev)=>(
            {
              ...prev,
              pricing_policy_discount: {type : pricingPolicyOption, value : parsedDiscount},
  
            }
          ))
          break;
        default:
          console.log("Unknown section");
          break;
      }
    }, [selectedProduct]);
  //<--------------------ONCHANGE FUNCTIONALITY END----------------------------->


  //<-------------------- Handling Accordion toggle------------------------------>
    const handleMainAccordion = (id) => {
      setMainAccordionOpen((prev) => (prev === id ? null : id));
    };
    const handleSubAccordion = (uniqueId) => {
      setSubAccordionOpen((prev) => (prev === uniqueId ? null : uniqueId));
    };
  //<-------------------- Handling Accordion End------------------------------>


    
  // Function for ADD PRODUCT in to section
  const addProductToSection = useCallback(
    async (sectionIndex, section) => {
      switch (section) {
        case "MAIN_SECTION":
          setSectionItems((prev) =>
            prev.map((mainSection, mainSecIndex) =>
              mainSecIndex == sectionIndex
                ? {
                    ...mainSection,
                    errorMessages: {
                      ...mainSection.errorMessages,
                      manufacture:
                        !mainSection?.manufacture ||
                        mainSection?.manufacture.length == 0
                          ? "Manufacture is required."
                          : "",
                      product:
                        !mainSection?.product ||
                        Object.keys(mainSection.product).length === 0
                          ? "Product is required."
                          : "",
                      quantity:
                        !mainSection?.quantity || mainSection?.quantity == ""
                          ? "Quantity is required."
                          : "",
                      unit_type:
                        !mainSection?.unit_type || mainSection?.unit_type == ""
                          ? "Unit Type is required."
                          : "",
                      distributor:
                      !mainSection?.distributor || Object.keys(mainSection?.distributor).length === 0
                        ? "Distributor is required."
                        : "",
                    },
                  }
                : mainSection
            )
          );
      
          // Check if the item at sectionIndex passes all validations
          await sectionItems?.forEach((mainSectionItem, mainSectionIndex) => {
            if (mainSectionIndex === sectionIndex) {

              if(!mainSectionItem.product){
                /*
                 * Data format 
                  [
                    {
                        "name": "Ground",
                        "subSections": []
                    }
                  ]
                */
                return
              }
              const {
                name,
                manufacture,
                product,
                quantity,
                unit_type,
                distributor,
                standard_markup,
                markup_total_price,
                pricing_policy_discount,
                distributor_price_with_markup,
                isChildProductsAvailable ,
                gpl_price,
                initial_gpl_price,
                distributorList,
                isCertificateExpired,
                part_number
              } = mainSectionItem;


              let productData = { ...product, name : product.label ,  value: product?.productId, productCode : product.productCode }; 
              // Proceed if all validations pass
              if ( manufacture && manufacture.length > 0 && product &&Object.keys(product).length > 0 && quantity &&unit_type && Object.keys(distributor).length !==0  ) {
                // Check if an entry already exists for the sectionIndex
                const existingProduct = sectionBaseSavedProducts[
                  sectionIndex
                ]?.products?.find(
                  (item) => item?.product?.productCode === product.productCode
                );

                
                if (existingProduct && !isUpdateProductButtonSection?.[sectionIndex]?.[sectionIndex]) {
                  toast.error(
                    "The product already exists. Please delete it before adding or updating."
                  );
                  return;
                }

                const updatedData = {
                  [sectionIndex]: {
                    sectionName: name,
                    products: [
                      ...(sectionBaseSavedProducts[sectionIndex]?.products ||
                        []),
                      {
                        manufacture,
                        distributor,
                        product : productData,
                        pricing_policy_discount,
                        distributor_price_with_markup,
                        quantity,
                        unit_type,
                        standard_markup,
                        markup_total_price,
                        isChildProductsAvailable
                      },
                    ],
                    subSections: sectionBaseSavedProducts[sectionIndex]?.subSections || {},
                  },
                };



                let selectedDistributor = null
                let distributorOptions = null
                if(distributor.value !== ''){
                  distributorOptions = distributorList
                  selectedDistributor = {
                    id: distributor.value,
                    name : distributor.name,
                    price : distributor.price,
                    currency : distributor.currency,
                    initial_price: distributor.initial_price,
                    markup_price : distributor.markup_price
                }
                }
                const formattedData = {
                  product_id : productData.value,
                  product_name : productData.name,
                  product_code : productData.productCode,
                  // product: {  
                  //   value: productData.name,
                  //   label: productData.name,
                  //   productId : productData.value,
                  //   productCode : productData.productCode,
                  //   data :  {
                  //     logistic_fee : productData.data.logistic_fee,
                  //     custom_fee :productData.data.custom_fee,
                  //     logistic_buffer_charge : productData.data.logistic_buffer_charge,
                  //   }
                  // },
                  logistic_fee : productData.data.logistic_fee,
                  custom_fee :productData.data.custom_fee,
                  logistic_buffer_charge : productData.data.logistic_buffer_charge,
                  part_number : part_number,
                  gpl_price : gpl_price,
                  manufacture : manufacture,
                  discount : pricing_policy_discount.value,
                  pricing_policy : pricing_policy_discount.type,
                  quantity : quantity,
                  unit_type : unit_type,
                  standard_markup : standard_markup,
                  total_price : markup_total_price,
                  distributor : selectedDistributor,
                  distributors : distributorOptions,
                  isCertificateExpired : isCertificateExpired,
                  initial_gpl_price : initial_gpl_price,
                  isChildProductsAvailable : isChildProductsAvailable
                }

                if(existingProduct){
                  setSectionBaseSavedProducts((prev)=>
                     ({
                      ...prev,
                      [sectionIndex] : {
                        ...prev[sectionIndex],
                        products : prev[sectionIndex].products?.map((sectionItem, sectionItemIndex)=>
                          sectionItem.product.productCode == product.productCode ?
                           {
                             ...sectionItem,
                             manufacture,
                             distributor,
                             product : productData,
                             pricing_policy_discount,
                             distributor_price_with_markup,
                             quantity,
                             unit_type,
                             standard_markup,
                             markup_total_price,
                             isChildProductsAvailable
                           }: sectionItem
                       )

                      }  
                     })
                  )
                  setSectionItems((prev) =>
                    prev.map((sectionItem, secIndex) =>
                      secIndex === sectionIndex
                        ? {
                            ...sectionItem,
                            productData: sectionItem.productData.map((item)=>
                              item.product_code ==product.productCode ?
                            {
                              ...item,
                              product_id : productData.value,
                              product_name : productData.name,
                              product_code : productData.productCode,
                              logistic_fee : productData.data.logistic_fee,
                              custom_fee :productData.data.custom_fee,
                              logistic_buffer_charge : productData.data.logistic_buffer_charge,
                              part_number : part_number,
                              gpl_price : gpl_price,
                              manufacture : manufacture,
                              discount : pricing_policy_discount.value,
                              pricing_policy : pricing_policy_discount.type,
                              quantity : quantity,
                              unit_type : unit_type,
                              standard_markup : standard_markup,
                              total_price : markup_total_price,
                              distributor : selectedDistributor,
                              distributors : distributorOptions,
                              isCertificateExpired : isCertificateExpired,
                              initial_gpl_price : initial_gpl_price,
                              isChildProductsAvailable : isChildProductsAvailable
                            } : item),
                            filteredProductData:sectionItem.filteredProductData.map((item)=>
                              item.product_code ==product.productCode ?
                            {
                              ...item,
                              product_id : productData.value,
                              product_name : productData.name,
                              product_code : productData.productCode,
                              logistic_fee : productData.data.logistic_fee,
                              custom_fee :productData.data.custom_fee,
                              logistic_buffer_charge : productData.data.logistic_buffer_charge,
                              part_number : part_number,
                              gpl_price : gpl_price,
                              manufacture : manufacture,
                              discount : pricing_policy_discount.value,
                              pricing_policy : pricing_policy_discount.type,
                              quantity : quantity,
                              unit_type : unit_type,
                              standard_markup : standard_markup,
                              total_price : markup_total_price,
                              distributor : selectedDistributor,
                              distributors : distributorOptions,
                              isCertificateExpired : isCertificateExpired,
                              initial_gpl_price : initial_gpl_price,
                              isChildProductsAvailable : isChildProductsAvailable
                            } : item) ,
                          }
                        : sectionItem
                    )
                  );
                  toast.success(`Product Updated.`); 
                }else{
                  // if(isEditQuotation){

                    
                
                      /* 
                      * IF IT IS A NEW SECTION
                      */                  
                      setSectionItems((prev) =>
                        prev.map((sectionItem, secIndex) =>
                          secIndex === sectionIndex
                            ? {
                                ...sectionItem,
                                productData: [...(sectionItem.productData || []), formattedData],
                                filteredProductData:[...(sectionItem.productData || []), formattedData],
                              }
                            : sectionItem
                        )
                      );
                      
                    // }

                  
                  
                  toast.success(`New product added.`);
                  setSectionBaseSavedProducts((prev) => ({
                    ...prev,
                    ...updatedData,
                  }));
                }

              }
            }
          });

          break;
        case "SUB_SECTION":
          const { index, subIdx } = sectionIndex;
          setSectionItems((prev) =>
            prev.map((mainSection, mainSecIndex) =>
              mainSecIndex == index
                ? {
                    ...mainSection,
                    subSections: mainSection.subSections.map(
                      (subSection, subSecIndex) =>
                        subSecIndex == subIdx
                          ? {
                              ...subSection,
                              errorMessages: {
                                ...subSection.errorMessages,
                                manufacture:
                                  !mainSection?.subSections[subIdx]
                                    .manufacture ||
                                  mainSection?.subSections[subIdx].manufacture
                                    .length == 0
                                    ? "Manufacture is required."
                                    : "",
                                product:
                                  !mainSection?.subSections[subIdx]?.product ||
                                  Object.keys(
                                    mainSection.subSections[subIdx].product
                                  ).length === 0
                                    ? "Product is required."
                                    : "",
                                quantity:
                                  !mainSection.subSections[subIdx]?.quantity ||
                                  mainSection.subSections[subIdx]?.quantity ==
                                    ""
                                    ? "Quantity is required."
                                    : "",
                                unit_type:
                                  !mainSection.subSections[subIdx].unit_type ||
                                  mainSection.subSections[subIdx]?.unit_type ==
                                    ""
                                    ? "Unit Type is required."
                                    : "",
                                distributor:
                                    !mainSection.subSections[subIdx]?.distributor || Object.keys(mainSection.subSections[subIdx]?.distributor).length === 0
                                    ? "Distributor is required."
                                    : "",
                              },
                            }
                          : subSection
                    ),
                  }
                : mainSection
            )
          );

          // Check if the item at sectionIndex passes all validations
          await sectionItems.forEach((mainSectionItem, mainSectionIndex) => {
            if (mainSectionIndex === index) {
              mainSectionItem.subSections?.map(
                (subSection, subSectionIndex) => {
                  if (subSectionIndex == subIdx) {
                    if(!subSection.product){
                      /*
                       * Data format 
                          [
                              {
                                  "name": "Ground",
                                  "subSections": [
                                      {
                                          "name": "room"
                                      }
                                  ],
                                  "errorMessage": ""
                              }
                          ]
                      */
                      return
                    }
                    const {
                      name,
                      manufacture,
                      product,
                      quantity,
                      distributor,
                      unit_type,
                      standard_markup,
                      markup_total_price,
                      isChildProductsAvailable,
                      pricing_policy_discount,
                      distributor_price_with_markup,
                      gpl_price,
                      distributorList,
                      isCertificateExpired,
                      initial_gpl_price,
                      part_number
                    } = subSection;
              
                    let productData = { ...product,name : product.label, value: product.productId , productCode : product.productCode }; 

                    // Proceed if all validations pass
                    if (name &&manufacture &&manufacture.length > 0 &&product &&Object.keys(product).length > 0 && quantity &&unit_type && Object.keys(distributor).length !==0 ) {
                      // #All ready exist
                      // Check if an entry already exists for the sectionIndex
                      if (sectionBaseSavedProducts?.[index]?.subSections?.[subIdx]) {

                        // EXISTED ONE----------------------------------------------
                        const existingProduct = sectionBaseSavedProducts[index].subSections[subIdx]?.find((item) => item?.product?.productCode === product.productCode);
  
                        if (existingProduct && !isUpdateProductButtonSection?.[index]?.subSections?.[subIdx]) {
                          toast.error("The product already exists. Please delete it before adding or updating.");
                          return;
                        }

                        const newData = {
                          sectionName: name,
                          manufacture,
                          distributor,
                          product : productData,
                          pricing_policy_discount,
                          distributor_price_with_markup,
                          quantity,
                          unit_type,
                          standard_markup,
                          markup_total_price,
                          isChildProductsAvailable
                        };

                        sectionBaseSavedProducts[index].subSections[subIdx].push(newData);
                        // Update the existing entry at sectionIndex
                        const updatedData = {
                          [index]: {
                            ...sectionBaseSavedProducts[index],
                            sectionName : mainSectionItem.name,
                            subSections: {
                              ...sectionBaseSavedProducts[index]?.subSections,
                            },
                          },
                        };


                        let selectedDistributor = null
                        let distributorOptions = null
                        if(distributor.value !== ''){
                          distributorOptions = distributorList
                          selectedDistributor = {
                            id: distributor.value,
                            name : distributor.name,
                            price : distributor.price,
                            currency : distributor.currency,
                            initial_price: distributor.initial_price,
                            markup_price : distributor.markup_price
                        }
                        }
                        
                        console.log("productData--------------------------->SUB SECTION-1", productData);
                        const formattedData = {
                          product_id : productData.value,
                          product_name : productData.name,
                          product_code : productData.productCode,
                          part_number : part_number,
                          gpl_price : gpl_price,
                          manufacture : manufacture,
                          discount : pricing_policy_discount.value,
                          pricing_policy : pricing_policy_discount.type,
                          // product: {  
                          //   value: productData.name,
                          //   label: productData.name,
                          //   productId : productData.value,
                          //   productCode : productData.productCode,
                          //   data :  {
                          //     logistic_fee : productData.data.logistic_fee,
                          //     custom_fee :productData.data.custom_fee,
                          //     logistic_buffer_charge : productData.data.logistic_buffer_charge,
                          //   }
                          // },
                          logistic_fee : productData.data.logistic_fee,
                          custom_fee :productData.data.custom_fee,
                          logistic_buffer_charge : productData.data.logistic_buffer_charge,
                          quantity : quantity,
                          unit_type : unit_type,
                          standard_markup : standard_markup,
                          total_price : markup_total_price,
                          distributor : selectedDistributor,
                          distributors : distributorOptions,
                          isCertificateExpired : isCertificateExpired,
                          initial_gpl_price : initial_gpl_price,
                          isChildProductsAvailable : isChildProductsAvailable
                        }
                        if(existingProduct){
                          setSectionBaseSavedProducts((prev) => ({
                            ...prev,
                            [index]: {
                              ...prev[index],
                              subSections: {
                                ...prev[index].subSections,
                                [subIdx]: [
                                  // Filter out any item with the same productCode
                                  ...prev[index]?.subSections?.[subIdx]?.filter(
                                    (subSectionItem) => subSectionItem.product.productCode !== product.productCode
                                  ),
                                  // Add the updated item
                                  {
                                    sectionName: name,
                                    manufacture,
                                    distributor,
                                    product: productData,
                                    pricing_policy_discount,
                                    distributor_price_with_markup,
                                    quantity,
                                    unit_type,
                                    standard_markup,
                                    markup_total_price,
                                    isChildProductsAvailable,
                                  },
                                ],
                              },
                            },
                          }));
 
                          setSectionItems((prev) =>
                            prev.map((sectionItem, secIndex) =>
                              secIndex === index
                                ? {
                                    ...sectionItem,
                                    subSections: sectionItem.subSections?.map((subSection, subSecIndex) =>
                                      subSecIndex === subIdx
                                        ? {
                                            ...subSection,
                                            productData: subSection.productData.map((item)=>
                                              item.product_code ==product.productCode ?
                                            {
                                              ...item,
                                              product_id : productData.value,
                                              product_name : productData.name,
                                              product_code : productData.productCode,
                                              part_number : part_number,
                                              gpl_price : gpl_price,
                                              manufacture : manufacture,
                                              discount : pricing_policy_discount.value,
                                              pricing_policy : pricing_policy_discount.type,
                                              logistic_fee : productData.data.logistic_fee,
                                              custom_fee :productData.data.custom_fee,
                                              logistic_buffer_charge : productData.data.logistic_buffer_charge,
                                              quantity : quantity,
                                              unit_type : unit_type,
                                              standard_markup : standard_markup,
                                              total_price : markup_total_price,
                                              distributor : selectedDistributor,
                                              distributors : distributorOptions,
                                              isCertificateExpired : isCertificateExpired,
                                              initial_gpl_price : initial_gpl_price,
                                              isChildProductsAvailable : isChildProductsAvailable
                                            } : item),
                                            filteredProductData:subSection.filteredProductData.map((item)=>
                                              item.product_code ==product.productCode ?
                                            {
                                              ...item,
                                              product_id : productData.value,
                                              product_name : productData.name,
                                              product_code : productData.productCode,
                                              part_number : part_number,
                                              gpl_price : gpl_price,
                                              manufacture : manufacture,
                                              discount : pricing_policy_discount.value,
                                              pricing_policy : pricing_policy_discount.type,
                                              logistic_fee : productData.data.logistic_fee,
                                              custom_fee :productData.data.custom_fee,
                                              logistic_buffer_charge : productData.data.logistic_buffer_charge,
                                              quantity : quantity,
                                              unit_type : unit_type,
                                              standard_markup : standard_markup,
                                              total_price : markup_total_price,
                                              distributor : selectedDistributor,
                                              distributors : distributorOptions,
                                              isCertificateExpired : isCertificateExpired,
                                              initial_gpl_price : initial_gpl_price,
                                              isChildProductsAvailable : isChildProductsAvailable
                                            } : item) ,
                                          }
                                        : subSection
                                    ),
                                  }
                                : sectionItem
                            )
                          );
                
                          toast.success(`Product Updated1.`); 
                          return
                        }else{
                          // if(isEditQuotation){

                            /* 
                             * Edit quotation 
                             * product adding to product to list  
                             */
           
                            

                              /* 
                              * IF IT IS A NEW SUB SECTION
                              */
                              setSectionItems((prev) =>
                                prev.map((sectionItem, secIndex) =>
                                  secIndex === index
                                    ? {
                                        ...sectionItem,
                                        subSections: sectionItem.subSections?.map((subSection, subSecIndex) =>
                                          subSecIndex === subIdx
                                            ? {
                                                ...subSection,
                                                productData: [...(subSection.productData || []), formattedData],
                                                filteredProductData: [...(subSection.filteredProductData || []), formattedData],
                                              }
                                            : subSection
                                        ),
                                      }
                                    : sectionItem
                                )
                              );
                              
             
                          // }
                          toast.success(`New product added.`);
                          setSectionBaseSavedProducts((prev) => ({...prev,...updatedData}));
                        }


                      } else {
                        console.log("iam here--------");
                        
                        const existingProduct = sectionBaseSavedProducts?.[index]?.subSections?.[subIdx]?.find(
                          (item) => item?.product?.productCode === product.productCode
                        );

                        if (existingProduct && !isUpdateProductButtonSection?.[index]?.subSections?.[subIdx]) {
                          toast.error("The product already exists. Please delete it before adding or updating.");
                          return;
                        }
                        // Create the new subsection entry, using `subIdx` as the key
                        let newSubSection = {
                          
                          [subIdx]: [
                            {
                              sectionName: name,
                              manufacture,
                              distributor,
                              product : productData,
                              pricing_policy_discount,
                              distributor_price_with_markup,
                              quantity,
                              unit_type,
                              standard_markup,
                              markup_total_price,
                              isChildProductsAvailable
                            },
                          ],
                        };
                        const updatedMainSection = {
                          [index]: {
                            ...sectionBaseSavedProducts?.[index],
                            sectionName : mainSectionItem.name,
                            subSections: {
                              ...sectionBaseSavedProducts?.[index]?.subSections,
                              ...newSubSection,
                            },
                          },
                        };

                        let selectedDistributor = null
                        let distributorOptions = null
                        if(distributor.value !== ''){
                          distributorOptions = distributorList
                          selectedDistributor = {
                            id: distributor.value,
                            name : distributor.name,
                            price : distributor.price,
                            currency : distributor.currency,
                            initial_price: distributor.initial_price,
                            markup_price : distributor.markup_price
                        }
                        }

                        console.log("productData--------------------------->SUB SECTION", productData);
                        
                        const formattedData = {
                          product_id : productData.value,
                          product_name : productData.name,
                          product_code : productData.productCode,
                          part_number : part_number,
                          gpl_price : gpl_price,
                          manufacture : manufacture,
                          discount : pricing_policy_discount.value,
                          pricing_policy : pricing_policy_discount.type,
                          // product: {  
                          //   value: productData.name,
                          //   label: productData.name,
                          //   productId : productData.value,
                          //   productCode : productData.productCode,
                          //   data :  {
                          //     logistic_fee : productData.data.logistic_fee,
                          //     custom_fee :productData.data.custom_fee,
                          //     logistic_buffer_charge : productData.data.logistic_buffer_charge,
                          //   }
                          // },
                          logistic_fee : productData.data.logistic_fee,
                          custom_fee :productData.data.custom_fee,
                          logistic_buffer_charge : productData.data.logistic_buffer_charge,
                          quantity : quantity,
                          unit_type : unit_type,
                          standard_markup : standard_markup,
                          total_price : markup_total_price,
                          distributor : selectedDistributor,
                          distributors : distributorOptions,
                          isCertificateExpired : isCertificateExpired,
                          initial_gpl_price : initial_gpl_price,
                          isChildProductsAvailable : isChildProductsAvailable
                        }
                        if(existingProduct){
                          setSectionBaseSavedProducts((prev) => ({
                            ...prev,
                            [index]: {
                              ...prev[index],
                              subSections: {
                                ...prev[index].subSections,
                                [subIdx]: prev[index]?.subSections?.[subIdx]?.map((subSectionItem) =>
                                  subSectionItem.product.productCode === product.productCode
                                    ? {
                                        sectionName: name,
                                        manufacture,
                                        distributor,
                                        product: productData,
                                        pricing_policy_discount,
                                        distributor_price_with_markup,
                                        quantity,
                                        unit_type,
                                        standard_markup,
                                        markup_total_price,
                                        isChildProductsAvailable,
                                      }
                                    : subSectionItem
                                ),
                              },
                            },
                          }));
                          setSectionItems((prev)=>
                            prev.map((sectionItem, secIndex)=>
                            secIndex === index ?
                            {
                              ...sectionItem,
                              subSections : sectionItem.subSections.map((subSection, subSecIndex)=>
                                subSecIndex == subIdx ? 
                                {
                                  ...subSection,
                                  productData: subSection.productData.map((item)=>
                                    item.product_code ==product.productCode ?
                                  {
                                    ...item,
                                    product_id : productData.value,
                                    product_name : productData.name,
                                    product_code : productData.productCode,
                                    part_number : part_number,
                                    gpl_price : gpl_price,
                                    manufacture : manufacture,
                                    discount : pricing_policy_discount.value,
                                    pricing_policy : pricing_policy_discount.type,
                                    logistic_fee : productData.data.logistic_fee,
                                    custom_fee :productData.data.custom_fee,
                                    logistic_buffer_charge : productData.data.logistic_buffer_charge,
                                    quantity : quantity,
                                    unit_type : unit_type,
                                    standard_markup : standard_markup,
                                    total_price : markup_total_price,
                                    distributor : selectedDistributor,
                                    distributors : distributorOptions,
                                    isCertificateExpired : isCertificateExpired,
                                    initial_gpl_price : initial_gpl_price,
                                    isChildProductsAvailable : isChildProductsAvailable
                                  } : item),
                                  filteredProductData:subSection.filteredProductData.map((item)=>
                                    item.product_code ==product.productCode ?
                                  {
                                    ...item,
                                    product_id : productData.value,
                                    product_name : productData.name,
                                    product_code : productData.productCode,
                                    part_number : part_number,
                                    gpl_price : gpl_price,
                                    manufacture : manufacture,
                                    discount : pricing_policy_discount.value,
                                    pricing_policy : pricing_policy_discount.type,
                                    logistic_fee : productData.data.logistic_fee,
                                    custom_fee :productData.data.custom_fee,
                                    logistic_buffer_charge : productData.data.logistic_buffer_charge,
                                    quantity : quantity,
                                    unit_type : unit_type,
                                    standard_markup : standard_markup,
                                    total_price : markup_total_price,
                                    distributor : selectedDistributor,
                                    distributors : distributorOptions,
                                    isCertificateExpired : isCertificateExpired,
                                    initial_gpl_price : initial_gpl_price,
                                    isChildProductsAvailable : isChildProductsAvailable
                                  } : item) ,
                                } : 
                                subSection
                              )
                              // productData : [...(sectionItem.productData || []), formattedData],
                              // filteredProductData : [...(sectionItem.filteredProductData || []),formattedData],
                            }: sectionItem
                        ))
                         toast.success(`Product Updated.`); 
                         return
                        }else{
                            // if(isEditQuotation){

                              /* 
                              * Edit quotation 
                              * product adding to product to list  
                              */
                            
                              

                              /* 
                              * IF IT IS A NEW SUB SECTION
                              */
                                setSectionItems((prev)=>
                                  prev.map((sectionItem, secIndex)=>
                                  secIndex === index ?
                                  {
                                    ...sectionItem,
                                    subSections : sectionItem.subSections.map((subSection, subSecIndex)=>
                                      subSecIndex == subIdx ? 
                                      {
                                        ...subSection,
                                        productData : [...(subSection.productData || []), formattedData],
                                        filteredProductData : [...(subSection.filteredProductData || []),formattedData],
                                      } : 
                                      subSection
                                    )
                                    // productData : [...(sectionItem.productData || []), formattedData],
                                    // filteredProductData : [...(sectionItem.filteredProductData || []),formattedData],
                                  }: sectionItem
                              ))
                            // }
                            // Update the main state with the new subsection structure
                            setSectionBaseSavedProducts((prev) => ({...prev,...updatedMainSection}));
                            toast.success(`New product added.`);
                        }
         
                      }
                    }
                  }
                }
              );
            }
          });
          break;
        case 'NO_SECTION': 
          setNoSectionFormInputErrorMessage((prev)=>(
            {
              ...prev,
              product : !selectedProduct.productId ? 'Product is required.' : '',
              distributor : selectedProduct.distributor && Object.keys(selectedProduct.distributor
              )?.length ==0 ? 'Distributor is required.' : '',
              unit_type : !selectedProduct.unit_type || selectedProduct.unit_type =='' ? 'Unit Type is required.' : '',
              quantity : selectedProduct.quantity =='' ? 'Quantity is required.' : ''
            }
          ))
          const {label ,manufacture, productId,productCode, distributor, unit_type, quantity, data, standard_markup, markup_total_price, isChildProductsAvailable, pricing_policy_discount, distributor_price_with_markup,  part_number, gpl_price, distributorList, isCertificateExpired, initial_gpl_price} = selectedProduct
          if(label && productId && distributor && unit_type && quantity){

            
            // EXISTED ONE----------------------------------------------
            const existingProduct = notSectionBaseSavedProduct?.find((item) => item?.product?.productCode === productCode);
            if (existingProduct && isUpdateProductButtonNoSection) {
              toast.error("The product already exists. Please delete it before adding or updating.");
              return;
            }
            const newProduct   = {
              manufacture : manufacture,
              distributor,
              product : {name : label, value : productId, productCode: productCode},
              pricing_policy_discount,
              distributor_price_with_markup,
              quantity,
              unit_type,
              standard_markup,
              markup_total_price,
              isChildProductsAvailable,
              logistic_fee : selectedProduct.product.data.logistic_fee,
              custom_fee :selectedProduct.product.data.custom_fee,
              logistic_buffer_charge : selectedProduct.product.data.logistic_buffer_charge,
           };


          /* <---------------------->*/
          let selectedDistributor = null
          let distributorOptions = null
          if(distributor.value !== ''){
            distributorOptions = distributorList
            selectedDistributor = {
              id: distributor.value,
              name : distributor.name,
              price : distributor.price,
              currency : distributor.currency,
              initial_price: distributor.initial_price,
              markup_price : distributor.markup_price
          }
          }
          

          
          const formattedData = {
            product_id : newProduct.product.value,
            product_name : newProduct.product.name,
            product_code : newProduct.product.productCode,
            part_number : part_number,
            gpl_price : gpl_price,
            // product: {  
            //   value: productData.name,
            //   label: productData.name,
            //   productId : productData.value,
            //   productCode : productData.productCode,
            //   data :  {
            //     logistic_fee : productData.data.logistic_fee,
            //     custom_fee :productData.data.custom_fee,
            //     logistic_buffer_charge : productData.data.logistic_buffer_charge,
            //   }
            // },
            logistic_fee : selectedProduct.product.data.logistic_fee,
            custom_fee :selectedProduct.product.data.custom_fee,
            logistic_buffer_charge : selectedProduct.product.data.logistic_buffer_charge,
            manufacture : newProduct.manufacture,
            discount : newProduct.pricing_policy_discount.value,
            pricing_policy : newProduct.pricing_policy_discount.type,
            quantity : newProduct.quantity,
            unit_type : newProduct.unit_type,
            standard_markup : newProduct.standard_markup,
            total_price : newProduct.markup_total_price,
            distributor : newProduct.distributor,
            distributors : distributorOptions,
            isCertificateExpired : isCertificateExpired,
            initial_gpl_price : initial_gpl_price,
            isChildProductsAvailable : isChildProductsAvailable
          }
      
            if(existingProduct){
              /* 
              * Updating product
              * This state isUpdateProductNoSection only work in case of Edit Quot 
              */
              setNotSectionBaseSaveProducts((prev)=>(
                prev.map(item=>
                  item.product.productCode === productCode ? newProduct : item
                )
              ))

              setSelectedProduct((prev) => ({
                ...prev,
                productData: prev.productData.map((item)=>
                  item.product_code ==productCode ?
                {
                  ...item,
                  product_id : newProduct.product.value,
                  product_name : newProduct.product.name,
                  product_code : newProduct.product.productCode,
                  part_number : part_number,
                  gpl_price : gpl_price,
                  logistic_fee : selectedProduct.product.data.logistic_fee,
                  custom_fee :selectedProduct.product.data.custom_fee,
                  logistic_buffer_charge : selectedProduct.product.data.logistic_buffer_charge,
                  manufacture : newProduct.manufacture,
                  discount : newProduct.pricing_policy_discount.value,
                  pricing_policy : newProduct.pricing_policy_discount.type,
                  quantity : newProduct.quantity,
                  unit_type : newProduct.unit_type,
                  standard_markup : newProduct.standard_markup,
                  total_price : newProduct.markup_total_price,
                  distributor : newProduct.distributor,
                  distributors : distributorOptions,
                  isCertificateExpired : isCertificateExpired,
                  initial_gpl_price : initial_gpl_price,
                  isChildProductsAvailable : isChildProductsAvailable
                } : item),
                filteredProductData:prev.filteredProductData.map((item)=>
                  item.product_code ==productCode ?
                {
                  ...item,
                  product_id : newProduct.product.value,
                  product_name : newProduct.product.name,
                  product_code : newProduct.product.productCode,
                  part_number : part_number,
                  gpl_price : gpl_price,
                  logistic_fee : selectedProduct.product.data.logistic_fee,
                  custom_fee :selectedProduct.product.data.custom_fee,
                  logistic_buffer_charge : selectedProduct.product.data.logistic_buffer_charge,
                  manufacture : newProduct.manufacture,
                  discount : newProduct.pricing_policy_discount.value,
                  pricing_policy : newProduct.pricing_policy_discount.type,
                  quantity : newProduct.quantity,
                  unit_type : newProduct.unit_type,
                  standard_markup : newProduct.standard_markup,
                  total_price : newProduct.markup_total_price,
                  distributor : newProduct.distributor,
                  distributors : distributorOptions,
                  isCertificateExpired : isCertificateExpired,
                  initial_gpl_price : initial_gpl_price,
                  isChildProductsAvailable : isChildProductsAvailable
                } : item) ,
              }));
              toast.success(`Product Updated.`); 
            }else{
              // if(isEditQuotation){

                /* 
                 * Edit quotation 
                 * product adding to product list  
                */
                // let selectedDistributor = null
                // let distributorOptions = null
                // if(distributor.value !== ''){
                //   distributorOptions = distributorList
                //   selectedDistributor = {
                //     id: distributor.value,
                //     name : distributor.name,
                //     price : distributor.price,
                //     currency : distributor.currency,
                //     initial_price: distributor.initial_price,
                //     markup_price : distributor.markup_price
                // }
                // }
                

                
                // const formattedData = {
                //   product_id : newProduct.product.value,
                //   product_name : newProduct.product.name,
                //   product_code : newProduct.product.productCode,
                //   part_number : part_number,
                //   gpl_price : gpl_price,
                //   // product: {  
                //   //   value: productData.name,
                //   //   label: productData.name,
                //   //   productId : productData.value,
                //   //   productCode : productData.productCode,
                //   //   data :  {
                //   //     logistic_fee : productData.data.logistic_fee,
                //   //     custom_fee :productData.data.custom_fee,
                //   //     logistic_buffer_charge : productData.data.logistic_buffer_charge,
                //   //   }
                //   // },
                //   logistic_fee : selectedProduct.product.data.logistic_fee,
                //   custom_fee :selectedProduct.product.data.custom_fee,
                //   logistic_buffer_charge : selectedProduct.product.data.logistic_buffer_charge,
                //   manufacture : newProduct.manufacture,
                //   discount : newProduct.pricing_policy_discount.value,
                //   pricing_policy : newProduct.pricing_policy_discount.type,
                //   quantity : newProduct.quantity,
                //   unit_type : newProduct.unit_type,
                //   standard_markup : newProduct.standard_markup,
                //   total_price : newProduct.markup_total_price,
                //   distributor : newProduct.distributor,
                //   distributors : distributorOptions,
                //   isCertificateExpired : isCertificateExpired,
                //   initial_gpl_price : initial_gpl_price,
                //   isChildProductsAvailable : isChildProductsAvailable
                // }

                  setSelectedProduct((prev) => ({
                    ...prev,
                    filteredProductData: [...(prev.filteredProductData || []), formattedData],
                    productData :  [...(prev.productData || []), formattedData],
                  }));
                  
                // setQuotationProductData((prev)=>([...(Array.isArray(prev) ? prev : []), formattedData]))
              // }


              setNotSectionBaseSaveProducts((prev)=>([...prev,newProduct]))
              toast.success(`New product added.`);
            }


          }
       
          
          break
        default:
          console.log("UnKnown section");
          break;
      }
    },
    [sectionBaseSavedProducts, sectionItems,selectedProduct,notSectionBaseSavedProduct]
  );



  
  /* 
  * Function For formatting section based products
  */

 
  const formattedSavedProductsData = useMemo(() => {

    if (Object.keys(viewPopUpSection).length !== 0) {
      const { sectionIndex, section } = viewPopUpSection;
      switch (section) {
        case 'MAIN_SECTION':
          if(!sectionBaseSavedProducts?.[sectionIndex]?.products){
            return {}
          }
          let formattedProducts = sectionBaseSavedProducts[sectionIndex]?.products?.map((item) => {
            const basePrice = parseFloat(item.distributor.gpl_price || item.distributor.price || 0);
            const discountValue = parseFloat(item.pricing_policy_discount?.value || 0);

  
            const vendorUnitCost =  
            (item.pricing_policy_discount?.type == pricingPolicy.standard_pricing.value ||
             item.pricing_policy_discount?.type == pricingPolicy.distributor_discount.value ||
             item.pricing_policy_discount?.type == pricingPolicy.manufacture_discount.value)
              ? basePrice > 0
                ? (item.pricing_policy_discount?.type == pricingPolicy.distributor_discount.value ||
                   item.pricing_policy_discount?.type == pricingPolicy.manufacture_discount.value)
                  ? basePrice - basePrice * (discountValue / 100)
                  : basePrice // Fallback to basePrice if not a specific discount type
                : '0'
              : '0';

              
              const vendorTotalCost = vendorUnitCost * item.quantity

              const vendorTotalProfit = parseFloat(item.markup_total_price) - parseFloat(vendorTotalCost)
              return{
                product: { id: item.product.value, name: item.product.label, product_code : item.product.productCode },
                unit_type: item.unit_type,
                quantity: item.quantity,
                u_cost :   item.distributor.gpl_price ? item.distributor.gpl_price : item.distributor.price,
                t_cost : (parseFloat(item.distributor.gpl_price ? item.distributor.gpl_price : item.distributor.price) * parseFloat(item.quantity)).toFixed(2),
                standard_markup : item.standard_markup,
                u_price : item.distributor_price_with_markup,
                t_price : item.markup_total_price,
                pricing_policy : item.pricing_policy_discount, // PRICING POLICY
                v_discount : item.pricing_policy_discount?.value || '',
                v_unit_cost:parseFloat(vendorUnitCost)?.toFixed(2),
                v_total_cost : vendorTotalCost.toFixed(2),
                v_total_profit : vendorTotalProfit.toFixed(2),
                isChildProductsAvailable : item.isChildProductsAvailable,
                distributor : item.distributor
              }
      });
          const formattedProductData  = {
              sectionName : sectionBaseSavedProducts[sectionIndex].sectionName,
              section : section, 
              sectionIndex : sectionIndex,
              products : formattedProducts
          }
          return formattedProductData || {};
  
        case 'SUB_SECTION':
          const { index, subIdx } = sectionIndex;
          if(!sectionBaseSavedProducts[index] || !sectionBaseSavedProducts[index]?.subSections?.[subIdx]){
            return {}
          }
          let sectionName  = sectionBaseSavedProducts[index]?.subSections?.[subIdx]?.[0]?.sectionName
          const formattedSubSectionProducts = sectionBaseSavedProducts[index]?.subSections?.[subIdx]?.map((item) => {
            const basePrice = parseFloat(item.distributor.gpl_price || item.distributor.price || 0);
            const discountValue = parseFloat(item.pricing_policy_discount?.value || 0);

            const vendorUnitCost =
              (item.pricing_policy_discount?.type == pricingPolicy.standard_pricing.value ||
               item.pricing_policy_discount?.type == pricingPolicy.distributor_discount.value ||
               item.pricing_policy_discount?.type == pricingPolicy.manufacture_discount.value)
                ? basePrice > 0
                  ? (item.pricing_policy_discount?.type == pricingPolicy.distributor_discount.value ||
                     item.pricing_policy_discount?.type == pricingPolicy.manufacture_discount.value)
                    ? basePrice - basePrice * (discountValue / 100)
                    : basePrice // Fallback to basePrice if not a specific discount type
                  : '0'
                : '0';

                const vendorTotalCost = vendorUnitCost * item.quantity

                const vendorTotalProfit = parseFloat(item.markup_total_price) - parseFloat(vendorTotalCost)
              return{
                    product: { id: item.product.value, name: item.product.label, product_code : item.product.productCode},
                    unit_type: item.unit_type,
                    quantity: item.quantity,
                    u_cost :   item.distributor.gpl_price ? item.distributor.gpl_price : item.distributor.price,
                    t_cost : (parseFloat(item.distributor.gpl_price ? item.distributor.gpl_price : item.distributor.price) * parseFloat(item.quantity)).toFixed(2),
                    standard_markup : item.standard_markup,
                    u_price : item.distributor_price_with_markup,
                    t_price : item.markup_total_price,
                    pricing_policy : item.pricing_policy_discount, // PRICING POLICY
                    v_discount : item.pricing_policy_discount?.value || '',
                    v_unit_cost:parseFloat(vendorUnitCost)?.toFixed(2),
                    v_total_cost : vendorTotalCost.toFixed(2),
                    v_total_profit : vendorTotalProfit.toFixed(2),
                    isChildProductsAvailable : item.isChildProductsAvailable,
                    distributor : item.distributor
            }
      });
          const formattedSubProductData  = {
            sectionName : sectionName,
            section : section, 
            sectionIndex : {index, subIdx} ,
            products : formattedSubSectionProducts
        }
          return formattedSubProductData || {};
        
        case 'NO_SECTION':
          if(notSectionBaseSavedProduct.length ==0){
            return {}
          }
          const formattedNoSectionProduct = notSectionBaseSavedProduct.map((item)=>{

            const basePrice = parseFloat(item.distributor.gpl_price || item.distributor.price || 0);
            const discountValue = parseFloat(item.pricing_policy_discount?.value || 0);

            
            const vendorUnitCost =
              (item.pricing_policy_discount?.type == pricingPolicy.standard_pricing.value ||
               item.pricing_policy_discount?.type == pricingPolicy.distributor_discount.value ||
               item.pricing_policy_discount?.type == pricingPolicy.manufacture_discount.value)
                ? basePrice > 0
                  ? (item.pricing_policy_discount?.type == pricingPolicy.distributor_discount.value ||
                     item.pricing_policy_discount?.type == pricingPolicy.manufacture_discount.value)
                    ? basePrice - basePrice * (discountValue / 100)
                    : basePrice // Fallback to basePrice if not a specific discount type
                  : '0'
                : '0';

            const vendorTotalCost = vendorUnitCost * item.quantity

            const vendorTotalProfit = parseFloat(item.markup_total_price) - parseFloat(vendorTotalCost)
            return{
              product: {id : item.product.value, name : item.product.name, product_code : item.product.productCode },
              unit_type: item.unit_type,
              quantity: item.quantity,
              u_cost :   item.distributor.gpl_price ? item.distributor.gpl_price : item.distributor.price,
              t_cost : (parseFloat(item.distributor.gpl_price ? item.distributor.gpl_price : item.distributor.price) * parseFloat(item.quantity)).toFixed(2),
              standard_markup : item.standard_markup,
              u_price : item.distributor_price_with_markup,
              t_price : item.markup_total_price,
              pricing_policy : item.pricing_policy_discount, // PRICING POLICY
              v_discount : item.pricing_policy_discount?.value || '',
              v_unit_cost:parseFloat(vendorUnitCost)?.toFixed(2),
              v_total_cost : vendorTotalCost.toFixed(2),
              v_total_profit : vendorTotalProfit.toFixed(2),
              isChildProductsAvailable : item.isChildProductsAvailable,
              distributor : item.distributor
            }
          })
          const formattedNoSectionProductData = {
            sectionName : false,
            section : section, 
            products : formattedNoSectionProduct
          }
          return formattedNoSectionProductData || {};
          break;
        default:
          console.log("Unknown section");
          return {};
      }
    }
    return [];
  }, [sectionBaseSavedProducts, viewPopUpSection, notSectionBaseSavedProduct]);




  // <----------TERMS & CONDITION(add,remove)-------->
    const handleTermsConditionAccordion = (id) => {
      if (termsConditionAccordion === id) {
        setTermsConditionAccordionOpen();
      } else {
        setTermsConditionAccordionOpen(id);
      }
    };
    const addTermsAndCondition = async() => {
      try{
        if (newTerm.trim() !== '') {
          await handleAddTermsAndCondition(newTerm)
          setNewTerm(''); // Clear input field after adding
        }
      }catch(err){
        console.log('Error in add terms and condition function');
      }

    };
    const deleteTerm = async(id) => {
      try{
        await handleRemoveTermsAndCondition(id)
      }catch(err){
        console.log('Error in delete terms and condition function');
        
      }
    };
    // #Check Box
    const handleCheckboxChange = (index,value)=>{
      try{
        setTermsAndConditions((prev) => (
          prev.map((item, idx) =>
            idx === index
              ? { ...item, checked: value } 
              : item 
          )
        ));
      }catch(err){

      }
    }
  // <----------TERMS & CONDITION end-------->




    /*FOOTER Form inputs functions */
    const totalFinalPrice = useMemo(() => {
      let totalPrice = 0;
      let totalAppliedMarkup  = 0
      // Helper function to add markup_total_price of a product, if valid
      function addPrice(price) {
        const numericPrice = parseFloat(price);
        if (!isNaN(numericPrice)) {
          totalPrice += numericPrice;
        }
      }

      function addMarkup(value) {
        const numericPrice = parseFloat(value);
        if (!isNaN(numericPrice)) {
          totalAppliedMarkup += numericPrice;
        }
      }

      if(isSectionActive){
        // Traverse main sections and products
        for (const sectionKey in sectionBaseSavedProducts) {
          const   section = sectionBaseSavedProducts[sectionKey];

          // Add markup_total_price for each main product in the section
          if (section.products) {
            section.products.forEach(product => {
              addPrice(product.markup_total_price);
              addMarkup(product.standard_markup)
              // Add markup_total_price for supported products
              if (product.supportedProducts) {
                
                product.supportedProducts?.forEach(supportedProduct => {
                  // Checked product only
                  if(supportedProduct.checked){
                    addPrice(supportedProduct.markup_total_price);
                    addMarkup(supportedProduct.standard_markup)
                  }
                });
              }
            });
          }

          // Traverse subSections and products
          if (section.subSections) {
            for (const subSectionKey in section.subSections) {
              const subSection = section.subSections[subSectionKey];

              if (Array.isArray(subSection)) {
                // Subsection with an array of products
                subSection.forEach(subProduct => {
                  addPrice(subProduct.markup_total_price);
                  addMarkup(subProduct.standard_markup)
                  // Add markup_total_price for supported products
                  if (subProduct.supportedProducts) {
                      subProduct.supportedProducts?.forEach(supportedProduct => {

                      // Checked product only
                      if(supportedProduct.checked){
                        addPrice(supportedProduct.markup_total_price);
                        addMarkup(supportedProduct.standard_markup)
                      }

                    });
                  }
                });
              } else {
                // Subsection with a single product
                // addPrice(subSection[subSectionKey]?.[subProduct.product.value].markup_total_price);
                // addMarkup(subSection[subSectionKey]?.[subProduct.product.value].standard_markup)
                // // Add markup_total_price for supported products
                // if (subSection[subSectionKey]?.[subProduct.product.value].supportedProducts) {
                //   subSection[subSectionKey]?.[subProduct.product.value].supportedProducts.forEach(supportedProduct => {

                //     // Checked product only
                //     if(supportedProduct[subSectionKey]?.[subProduct.product.value].checked){
                //       addPrice(supportedProduct[subSectionKey]?.[subProduct.product.value].markup_total_price);
                //       addMarkup(supportedProduct[subSectionKey]?.[subProduct.product.value].standard_markup)
                //     }

                //   });
                // }

                
              }
            }
          }
        }

      }else{
        notSectionBaseSavedProduct.forEach(product => {
          addPrice(product.markup_total_price);
          addMarkup(product.standard_markup)
          // Add markup_total_price for supported products
          if (product.supportedProducts && product.supportedProducts[product.product.productCode]) {
            product.supportedProducts[product.product.productCode].forEach(supportedProduct => {

              // Checked product only
              if(supportedProduct.checked){
                addPrice(supportedProduct.markup_total_price);
                addMarkup(supportedProduct.standard_markup)
              }
            });
          }
        });
      }

      return {
        totalPrice : totalPrice.toFixed(2),
        totalMarkup : totalAppliedMarkup.toFixed(2),
      };
    }, [sectionBaseSavedProducts, notSectionBaseSavedProduct,isSectionActive]);


    const handleChangeSaberFee = (value) =>{
      
        const totalPrice  = parseFloat(totalFinalAmountWithoutCertificationFee)
        const totalPriceWithCertificationFee =  totalPrice +  parseFloat(value || 0);
        SetTotalFinalAmount(totalPriceWithCertificationFee.toFixed(2))

        quotationForm.setFieldValue('saber_fee', value)
    }

    const handleDiscountChange = (value)=>{
        try{

          // Parse values
          const totalPrice = (parseFloat(totalFinalAmountWithoutDiscount) || 0) + (parseFloat(quotationForm.values.saber_fee) || 0);
          const discountRate = parseFloat(value) / 100;
          const discount = isNaN(discountRate) ? 0 : totalPrice * discountRate;

          // Calculate total after discount
          const totalAfterDiscount = totalPrice - discount;

          // Update discount and final amount, with default to '0' if NaN
          SetTotalDiscountedPrice(discount.toFixed(2) || '0');
          SetTotalFinalAmount(totalAfterDiscount.toFixed(2) || '0');
          setTotalFinalAmountWithoutCertificationFee(totalAfterDiscount.toFixed(2) || '0')
          setAppliedDiscount(value);
        }catch(err){

        }
    }

    useEffect(()=>{
      /*
       * Initially setting
       */

        const totalAmount = totalFinalPrice.totalPrice;
        
        //#Tax
        const taxRate = parseFloat(appTaxAmount) / 100; 
        const tax = parseFloat(totalAmount) * parseFloat(taxRate);
        const totalWithTax = parseFloat(totalAmount) + parseFloat(tax);


        //#Markup
        const totalWithMarkup = parseFloat(totalFinalPrice.totalPrice);
        const markupRate = parseFloat(totalFinalPrice.totalMarkup);
        const totalWithOutMarkup = totalWithMarkup / (1 + (markupRate / 100));
        const appliedMarkup  = totalWithMarkup - parseFloat(totalWithOutMarkup);
        if(!isEditQuotation){
          setAppliedDiscount('0')
          quotationForm.setFieldValue('saber_fee', '0')
          SetTotalDiscountedPrice('0');
        }
        setTotalFinalAmountWithoutDiscount(totalWithTax.toFixed(2))
        setTotalFinalAmountWithoutCertificationFee(totalWithTax);
        setTotalTaxAmount(tax.toFixed(2))
        setTotalMarkupAmount(appliedMarkup.toFixed(2))
        SetTotalFinalAmount(totalWithTax.toFixed(2))
    },[appTaxAmount,totalFinalPrice.totalPrice,totalFinalPrice.totalMarkup, isSectionActive ,isEditQuotation])
  // <----------FOOTER Form inputs END----------->


  
  
  const handleDeleteSection = (section, sectionIndex)=>{

    
      switch(section){
        case 'MAIN_SECTION':

          setSectionItems((prevSection)=>
             prevSection.filter((item,index)=>(index !==sectionIndex))
          )
          setSectionBaseSavedProducts((prevSection)=>
          {     
             const updatedData = {...prevSection}
             delete updatedData[sectionIndex]
             return updatedData
          }
          )
          break;
        case 'SUB_SECTION':
          const {index , subIdx} = sectionIndex
          setSectionItems((prevSection) =>
            prevSection.map((section, idx) => {
                if (idx === index) {
                    return {
                        ...section,
                        subSections: section.subSections?.filter((_, subIndex) => subIndex !== subIdx),
                    };
                }
                return section;
            })
        );
        setSectionBaseSavedProducts((prevSection)=>
          {     
            const updatedData = {...prevSection}
            if(updatedData[index]?.subSections[subIdx]){
              delete updatedData[index].subSections[subIdx]
            }
            return updatedData
          }
        )

          break;
        default:
          console.log('Section un available');
          break;
      }
  }

  const handleAllCheckboxChange =  (value)=>{
    try{
        setTermsAndConditions((prev)=>
          prev.map((item)=>(
            {
              ...item,
              checked : value ? true : false
            }
          ))
        )
    }catch(error){

    }
  }
  //<================================================================QUOTATION EDIT START HERE=======================================================>
  const updatedSectionData = useMemo(()=>{
    // if(!isEditQuotationSectionActive && !isEditQuotation){
    //     return []
    // }
    const updatedSections = quotationProductData?.map((item) => ({
      name: item.section,
      section_id: item.section_id,
      productData : item.products,
      filteredProductData :item.products,
      subSections: item?.sub_sections?.map((subSection) => ({
        name: subSection.section,
        section_id: subSection.section_id,
        parent_id: subSection.parent_id,
        productData : subSection.products,
        filteredProductData :subSection.products,
      })),
      errorMessage: "",
    }));
    return updatedSections
  },[quotationProductData, isEditQuotationSectionActive, isEditQuotation])



  
  useEffect(()=>{
    // SECTION
    if(updatedSectionData?.length && isSectionActive){
      
     setSectionItems(updatedSectionData)
    }
    // SECTION LESS
    if(!isSectionActive){
      setSelectedProduct((
        {
          filteredProductData:  quotationProductData,
          productData : quotationProductData, 
        }))
    }
  },[isEditQuotationSectionActive, quotationProductData,isEditQuotation, updatedSectionData, isSectionActive])

  const handleSectionWiseSearch =(value, sectionIndex, section)=>{


    switch(section){
      case 'MAIN_SECTION':
        setSearchInput((prev)=>({
          ...prev,
          [sectionIndex] : {
            ...prev?.[sectionIndex],
            input : value,
          }
        }))
        
        const filteredData = sectionItems[sectionIndex]?.productData?.filter(
          (item) =>
            item.product_name?.toLowerCase().includes(value.toLowerCase()) ||
            item.product_code?.toLowerCase().includes(value.toLowerCase()) ||
            item.part_number?.toLowerCase().includes(value.toLowerCase())
        );
        setSectionItems((prev) =>
          prev.map((section, idx) =>
            idx == sectionIndex
              ? {
                  ...section,
                  filteredProductData: !value ? section.productData : filteredData,
                  productData :   section.productData
                }
              : section
          ))

        break;
      case 'SUB_SECTION':
        const {index, subIdx} =  sectionIndex;

        
        setSearchInput((prev) => ({
          ...prev,
          [index]: {
            ...prev?.[index],
            subSections: prev?.[index]?.subSections?.length // Check if subSections exist and have items
              ? prev[index].subSections.map((subSection, idx) =>
                  idx === subIdx
                    ? {
                        ...subSection,
                        input: value,
                      }
                    : subSection
                )
              : [
                  // Initialize with a new entry if subSections is empty
                  {
                    input: value.trim(),
                     
                  },
                ],
          },
        }));
        const filteredSubSectionData = sectionItems[index]?.subSections[subIdx]?.productData?.filter(
          (item) =>
            item.product_name?.toLowerCase().includes(value.toLowerCase()) ||
            item.product_code?.toLowerCase().includes(value.toLowerCase()) ||
            item.part_number?.toLowerCase().includes(value.toLowerCase())
        );
        setSectionItems((prev) =>
          prev.map((section, idx) =>
            idx == index
              ? {
                  ...section,
                  subSections : section.subSections.map(
                    (subSection, subSectionIdx)=>
                      subSectionIdx ==subIdx 
                    ?
                      (
                        {
                            ...subSection,
                            filteredProductData: !value ? subSection.productData : filteredSubSectionData,
                            productData :   subSection.productData
                        }
                      ) : subSection
                    ),
                }
              : section
          ))
        
        break;
        case 'NO_SECTION':
          const normalizedSearchInput = value?.toLowerCase() || '';

          const filteredNoSectionData = quotationProductData.filter((item) =>
            (item.product_name?.toLowerCase() || '').includes(normalizedSearchInput) ||
            (item.product_code?.toLowerCase() || '').includes(normalizedSearchInput) ||
            (item.part_number?.toLowerCase() || '').includes(normalizedSearchInput)
          );
          
          setSelectedProduct((prev) => ({
            ...prev,
            filteredProductData: !normalizedSearchInput ? quotationProductData : filteredNoSectionData,
            productData :   quotationProductData
          }));
          
            setSearchInput(normalizedSearchInput)
          break
        default:
          console.error("No section available");
          break;
        
    }

  }


  const handleButtonAddNewProductInEdit =(sectionIndex, section)=>{

      switch(section){
        case 'MAIN_SECTION':
          setSectionItems((prev)=>
            prev.map((sectionItem, index) =>
              index == sectionIndex 
              ?
                { 
                  errorMessage : "",
                  filteredProductData : sectionItem.filteredProductData,
                  productData :sectionItem.productData,
                  name :  sectionItem.name,
                  subSections :  sectionItem.subSections
                }
              :
              sectionItem
            )
          )
          setIsUpdateProductButtonSection((prev)=>({
            ...prev , 
            [sectionIndex] : {
              ...prev[sectionIndex],
              [sectionIndex] :false
            }
          }))
          break;
        case 'SUB_SECTION':
          const { index, subIdx } = sectionIndex;
          setSectionItems((prev)=>
            prev.map((sectionItem, secIndex) =>
              secIndex == index 
              ?
                {
                  ...sectionItem,
                  subSections :  sectionItem.subSections.map((subSection, subSecIndex)=>
                    subSecIndex === subIdx
                  ? {
                      filteredProductData : subSection.filteredProductData,
                      productData :subSection.productData,
                      name :  subSection.name,
                    } : subSection

                  )
                }
              :
              sectionItem
            )
          )
          setIsUpdateProductButtonSection((prev)=>({
            ...prev , 
            [index] : {
              ...prev[index],
              subSections : {
                ...prev[index]?.subSections,
                [subIdx] :  false
              }
            }
          }))
          break;
        case 'NO_SECTION':
          setSelectedProduct((prev)=>{
            const { filteredProductData }  = prev
            return { filteredProductData } 
          })
          setIsUpdateProductButtonNoSection(true)
          break;
        default:
          break
      }
  }

  /* 
   * Formatting Product related supporting product in case of quotation edit  
   */





  const formattedSupportingProduct = useMemo(() => {
    if (!isEditQuotation) {
      return {};
    }
  
    const finalOutput = {};
    if(isSectionActive){
        for(let sectionIndex in sectionBaseSavedProducts){
          if (!finalOutput[sectionIndex]) {
            finalOutput[sectionIndex] = {};
          }
  
          for(let subSectionIndex in sectionBaseSavedProducts[sectionIndex].subSections ){

              if(!finalOutput[sectionIndex][subSectionIndex]){
                finalOutput[sectionIndex][subSectionIndex] = {}
              }
              let subSectionProducts = {}
              for(let subSectionItemProducts of sectionBaseSavedProducts[sectionIndex].subSections[subSectionIndex] ){
                if(subSectionItemProducts.supportedProducts && subSectionItemProducts.supportedProducts.length !==0){
                  subSectionProducts[subSectionItemProducts.product.productCode] = subSectionItemProducts.supportedProducts || []
                }
              }
              finalOutput[sectionIndex][subSectionIndex] = subSectionProducts
          }
          let sectionProducts = {}
          for(let sectionItemProducts of sectionBaseSavedProducts[sectionIndex].products ){
            if(sectionItemProducts.supportedProducts && sectionItemProducts.supportedProducts?.length !==0){
              sectionProducts[sectionItemProducts.product.productCode] = sectionItemProducts.supportedProducts || []
            }
          }
          finalOutput[sectionIndex]["products"]  =  sectionProducts
        }
    }else{


      notSectionBaseSavedProduct.forEach((productItem) => {
        if (!productItem?.supportedProducts) {
          return;
        }

          
        const formattedSupportingProduct = productItem.supportedProducts?.[productItem.product.productCode]?.map((supportingProduct) => {
   
          let  formattedDistributors  = []
          if(supportingProduct.distributors?.length){
              formattedDistributors = supportingProduct.distributors.map((dist) => ({
                id: dist.id,
                name: dist.name,
                initial_price: dist.initial_price,
                currency: dist.currency,
                price: dist.price,
                markup_price: dist.markup_price,
              }));
          }


          
          return {
            id: supportingProduct.product.id,
            product_code : supportingProduct.product.productCode,
            product : {
              id : supportingProduct.product.id,
              name :  supportingProduct.product.name,
              productCode :supportingProduct.product.productCode,
            },
            name: supportingProduct.product.name,
            currency: supportingProduct.currency,
            gpl_price: supportingProduct.gpl_price,
            logistic_fee: supportingProduct.logistic_fee,
            custom_fee: supportingProduct.custom_fee,
            logistic_buffer_charge: supportingProduct.logistic_buffer_charge,
            distributors: formattedDistributors,
            distributor: supportingProduct.distributor,
            isCertificateExpired: supportingProduct.isCertificateExpired,
            initial_gpl_price: supportingProduct.initial_gpl_price,
            standard_markup :  supportingProduct.standard_markup,
            discount :  supportingProduct.discount,
            quantity : supportingProduct.quantity,
            unit_type :  supportingProduct.unit_type,
            pricing_policy  : supportingProduct.pricing_policy
          };
        });

        if(formattedSupportingProduct){
          finalOutput[productItem.product.productCode] = formattedSupportingProduct;
        }

      });
    }

    return finalOutput;
  }, [notSectionBaseSavedProduct, isEditQuotation , sectionBaseSavedProducts]);

  


// Function for handling product edit 
const handleProductEdit = (data, sectionIndex, section)=>{
  try{

    

        const { pricing_policy,initial_gpl_price,gpl_price , discount, quantity , unit_type, standard_markup, isChildProductsAvailable, product_name, product_id, product_code, manufacture, logistic_fee, custom_fee, logistic_buffer_charge } = data;

        console.log("data->", data);
        
    
        let  distributorOptions  = []
        let distributor = {}
        let distributorList = null;
        if(data?.distributors && data?.distributors?.length != 0){
          distributorList = data?.distributors
          distributor  = {label : (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 8px" }}>
              <span style={{ fontWeight: "500" }}>{data.distributor.name}</span>  
              <button
                type="button"
                style={{
                  padding: "4px 8px",
                  border: "none",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  borderRadius: "12px",
                  fontSize: "0.85em",
                  cursor: "pointer",
                }}
              >
                {data.distributor?.currency} {data.distributor.initial_price}
              </button>
            </div>
          ) , currency : data.distributor?.currency,name :  data.distributor.name, value : data.distributor.id,price : data.distributor.price, initial_price :  data.distributor.initial_price, markup_price : data.distributor.markup_price , noDistributor : false } //Working progress....................

          distributorOptions =  data?.distributors?.map((item)=>({label : (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 8px" }}>
              <span style={{ fontWeight: "500" }}>{item.name}</span>  
              <button
                type="button"
                style={{
                  padding: "4px 8px",
                  border: "none",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  borderRadius: "12px",
                  fontSize: "0.85em",
                  cursor: "pointer",
                }}
              >
                {item?.currency} {item.initial_price}
              </button>
            </div>
          ) ,currency : item?.currency,name :  item.name, value : item.id,price : item.price, initial_price :item.initial_price , lead_time : item.lead_time , markup_price : item.markup_price , noDistributor : false ,
          logistics : {
            custom_fee : data.custom_fee,
            logistic_fee : data.logistic_fee,
            logistic_buffer_charge : data.logistic_buffer_charge
          }
        }))
        }else{
          distributor = { value: '', label: 'No Distributor' , gpl_price : data.gpl_price, initial_gpl_price : data.initial_gpl_price, noDistributor : true}
          distributorOptions.push({ value: '', label: 'No Distributor' , gpl_price : data.gpl_price, initial_gpl_price : data.initial_gpl_price, noDistributor : true}) 
        }

        const basePrice =  distributor.gpl_price || distributor.price
        let logisticsCharge = logistic_fee;
        let customCharge = custom_fee;
        let bufferCharge  = logistic_buffer_charge;
        if (logisticsCharge <= 0) {
          logisticsCharge = 0;
        }
        if (customCharge <= 0) {
          customCharge = 0;
        }
        if (bufferCharge <= 0) {
          bufferCharge = 0;
        }
        const selectedSortOption  = 'PRICE';
        const initialBasePrice = distributor.initial_gpl_price || distributor.initial_price || 0
        const shipmentCharge =    calculateTotalShipment(initialBasePrice, logisticsCharge, customCharge, bufferCharge);
        const markupFee = (
          parseFloat(basePrice || 0) * 
          ((parseFloat(standard_markup || 0)) / 100)
        ).toFixed(2);
        

        const distributorPriceWithMarkup = calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', data.pricing_policy , basePrice,  data.standard_markup, data.quantity)
        const markupTotalPrice = calculatePrice('MARKUP_TOTAL_PRICE', data.pricing_policy , basePrice,  data.standard_markup, data.quantity)
        switch(section){
          case 'MAIN_SECTION':


            setSectionItems((prev) =>
              prev.map((section, idx) =>
                idx === sectionIndex
                  ? {
                      ...section,
                      product: {  

                                  value: product_name,
                                  label: product_name,
                                  productId : product_id,
                                  productCode : product_code,
                                  data :  {
                                    logistic_fee : logisticsCharge,
                                    custom_fee : customCharge,
                                    logistic_buffer_charge : bufferCharge
                                  }
                                },
                      standard_markup: parseFloat(standard_markup).toString() || "0",
                      manufacture : manufacture,
                      quantity : quantity || 1,
                      distributor : distributor || {}, // Default selection
                      distributor_price_with_markup :distributorPriceWithMarkup,
                      distributorOptions :  distributorOptions,
                      distributorList : distributorList,
                      selectedSortOption : selectedSortOption,
                      initial_gpl_price : initial_gpl_price,
                      noDistributor : distributor?.noDistributor,
                      gpl_price : gpl_price, // (included logistic fee + markup)
                      shipmentCharge :shipmentCharge,
                      markupFee : markupFee,
                      isChildProductsAvailable : isChildProductsAvailable,
                      pricingPolicyOption : pricing_policy,
                      pricing_policy_discount: {type : pricing_policy, value : discount},
                      markup_total_price : markupTotalPrice,
                      unit_type: unit_type,
                    }
                  : section
              )
            );
            setIsUpdateProductButtonSection((prev)=>({
              ...prev , 
              [sectionIndex] : {
                ...prev[sectionIndex],
                [sectionIndex] :true
              }
            }))
            break;
          case 'SUB_SECTION':
            const { index, subIdx } = sectionIndex;
            setSectionItems((prev) =>
              prev.map((section, idx) =>
                idx === index
                  ? {
                      ...section,
                      subSections: section.subSections?.map(
                        (subSecItem, subSecIdx) =>
                          subSecIdx == subIdx
                            ? {
                                ...subSecItem,
                                product: {  
                                  value: product_name,
                                  label: product_name,
                                  productId : product_id,
                                  productCode : product_code,
                                  data :  {
                                    logistic_fee : logisticsCharge,
                                    custom_fee : customCharge,
                                    logistic_buffer_charge : bufferCharge
                                  }
                                },
                                standard_markup: parseFloat(standard_markup).toString() || "0",
                                manufacture : manufacture,
                                quantity : quantity || 1,
                                distributor : distributor || {}, // Default selection
                                distributor_price_with_markup :distributorPriceWithMarkup,
                                distributorOptions :  distributorOptions,
                                distributorList : distributorList,
                                selectedSortOption : selectedSortOption,
                                initial_gpl_price : initial_gpl_price,
                                noDistributor : distributor?.noDistributor,
                                gpl_price : gpl_price, // (included logistic fee + markup)
                                shipmentCharge :shipmentCharge,
                                markupFee : markupFee,
                                isChildProductsAvailable : isChildProductsAvailable,
                                pricingPolicyOption : pricing_policy,
                                pricing_policy_discount: {type : pricing_policy, value : discount},
                                markup_total_price : markupTotalPrice,
                                unit_type: unit_type,
                                
                              }
                            : subSecItem
                      ),
                    }
                  : section
              )
            );
            setIsUpdateProductButtonSection((prev)=>({
              ...prev , 
              [index] : {
                ...prev[index],
                subSections : {
                  ...prev[index]?.subSections,
                  [subIdx] :  true
                }
              }
            }))
            break;
          case 'NO_SECTION':


            setSelectedProduct((prev)=>
              ({
                ...prev,
                product: {
                  data :  {
                    logistic_fee : logisticsCharge,
                    custom_fee : customCharge,
                    logistic_buffer_charge : bufferCharge
                  }
                },
                //Product setting-------
                label : data.product_name,
                value : data.product_name,
                productId : data.product_id,
                productCode : data.product_code,
                manufacture : data.manufacture,
                initial_gpl_price : data.initial_gpl_price,
                gpl_price : data.gpl_price,
                data :  {
                  manufacturer : data.manufacture,
                  isChildProductsAvailable : data.isChildProductsAvailable,
                  isCertificateExpired : data.isCertificateExpired,
                  initial_gpl_price : data.initial_gpl_price,
                  gpl_price : data.gpl_price
                },

                //Product setting end 
                distributorOptions: distributorOptions,
                standard_markup: parseFloat(standard_markup).toString() || "0",
                quantity: quantity,
                isChildProductsAvailable : data.isChildProductsAvailable,
                distributor: distributor || {}, // Default selection
                distributorList : distributorList,
                selectedSortOption : selectedSortOption,

                distributor_price_with_markup : distributorPriceWithMarkup,
                initial_gpl_price : initial_gpl_price,
                noDistributor : distributor?.noDistributor,
                gpl_price : distributor.gpl_price, // (included logistic fee + markup)
                shipmentCharge :shipmentCharge,
                markupFee : markupFee,

                pricingPolicyOption : pricing_policy,
                pricing_policy_discount: {type : pricing_policy, value : discount},
                markup_total_price : markupTotalPrice,
                unit_type: unit_type,
            }));
            setIsUpdateProductButtonNoSection(false)
            break
        }



  }catch(error){
    console.log(`function handleProductEdit Err`, error.message);
    
  }
}
const inputRef = useRef(null);
const handleFocus = () => {
  if (inputRef.current) {
    inputRef.current.focus(); // Focus the input element
  }
};


const viewModalProp = {
  viewModal,
  handleShowViewModal,
  formattedSavedProductsData,
  formattedSupportingProduct
};
  return (
    <Modal size="xl" isOpen={modal} toggle={handleShow}>
      <div style={{maxHeight : '787px', overflow : 'auto'}}>
        <ModalHeader toggle={handleShow}>{isEditQuotation ? 'Edit Quotation' : 'Add Quotation'}</ModalHeader>
        <Form
         onSubmit={quotationForm.handleSubmit}
         onKeyDown={(e)=>{
          if(e.key ==="Enter"){
            e.preventDefault()
          }
         }}
         >
          <ModalBody className="p-5">
            <Row>
              <Col className="mb-4">
                {errorMessage && (
                  <span className="invalidError d-flex justify-content-center">
                    {errorMessage}
                  </span>
                )}
                {successMessage && (
                  <span className="successMsg d-flex justify-content-center">
                    {successMessage}
                  </span>
                )}
              </Col>
              <Row>

                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="crm_ref_no">CRM Ref No:</Label>
                    <Input
                      type="text"
                      value={quotationForm.values.crm_ref_no}
                      required
                      onChange={quotationForm.handleChange}
                      id="crm_ref_no"
                      name="crm_ref_no"
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="project_name">Project Name:</Label>
                    <Input
                      type="text"
                      value={quotationForm.values.project_name}
                      required
                      onChange={quotationForm.handleChange}
                      id="project_name"
                      name="project_name"
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="sales">Select Salesperson:</Label>
                    <Select
                      value={selectedSales}
                      options={formattedSalesPersonData}
                      placeholder="Select a salesperson"
                      isSearchable
                      onChange={handleSalesSelectChange}
                    />
                    {quotationForm.errors.sales && (
                      <div className="invalidError d-flex justify-content-center">
                        {quotationForm.errors.sales}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label htmlFor="customer">Select Customer:</Label>
                    <Select
                      value={selectedCustomer}
                      options={formattedCustomerData}
                      placeholder="Select a customer"
                      isSearchable
                      onChange={handleCustomerSelectChange}
                      menuPortalTarget={document.body} 
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Prevent overlapping issues
                      }}
                    />
                    {quotationForm.errors.customer && (
                      <div className="invalidError d-flex justify-content-center">
                        {quotationForm.errors.customer}
                      </div>
                    )}
                  </FormGroup>
                </Col>
                {/* Check box */}
                <Col md={12} className="mb-2" >
                  <FormGroup switch>
                    <Input
                      type="switch"
                      checked={isSectionActive}
                      style={{width : '35px', height : '15px'}}
                      onClick={() => {
                        setSectionActive(!isSectionActive);
                        if(isEditQuotation){
                          if(isEditQuotationSectionActive){
                              setSelectedProduct({})
                          }else{
                              setSectionItems([])
                          }
                        }
                      }}
                      className="me-1"
                    />
                    <Label check>Enable Section</Label>
                  </FormGroup>
                </Col>

                {isSectionActive && <>
                  {/* Section */}
                  <Col md={4}>
                    <FormGroup>
                      <Label htmlFor="section">Enter Main Section Name:</Label>
                      <div className="d-flex">
                        <Input
                          type="text"
                          className="me-2"
                      
                          value={sectionName}
                          onChange={(e) => {setSectionName(e.target.value)}}
                          id="section"
                          name="section"
                        />
                        <Button color="success" onClick={addSection}>
                          Add
                        </Button>

                      </div>
                    </FormGroup>
                  </Col>
                  <Col md={12} >
                    {sectionItems?.length > 0 && (
                      <Card style={{ border: "1px solid #ced4da"  }}>
                        {/*********************** Main Accordion ***************************/}
                        <Accordion
                          flush                     
                          open={openMainAccordion}
                          toggle={handleMainAccordion}
                          // style={{padding :'5px'}}
                        >
                          {sectionItems?.map((section, index) => (
                            <AccordionItem key={index} className={index !==0 ?'mt-2' :''}>
                              <AccordionHeader targetId={index} style={{backgroundColor :'#afc9f9'}}>
                                <div className="accordionSectionHeader">
                                   <span>{section.name}</span>
                                   <button 
                                   type="button"
                                   onClick={(e)=>handleDeleteSection('MAIN_SECTION', index)}
                                   >
                                    <span >
                                      <i class="bi bi-trash-fill"></i>
                                    </span>
                                  </button>
                                </div>

                              </AccordionHeader>
                              <AccordionBody accordionId={index}>
                                <Col className="mb-4">
                                  {section.errorMessage && (
                                    <span className="invalidError d-flex justify-content-center">
                                      {section.errorMessage}
                                    </span>
                                  )}
                                </Col>
                                <Col md={4}>
                                  <FormGroup>
                                    <Label>Enter Sub Section Name:</Label>
                                    <div className="d-flex">
                                      <Input
                                        type="text"
                                        className="me-2"
                                        value={subSectionNames[index] || ""}
                                        onChange={(e) =>
                                          setSubSectionNames((prev) => ({
                                            ...prev,
                                            [index]: e.target.value,
                                          }))
                                        }
                                      />
                                      <Button
                                        color="success"
                                        onClick={() => addSubSection(index)}
                                      >
                                        Add
                                      </Button>
                                    </div>
                                  </FormGroup>
                                </Col>
                                {/******************** Sub Accordion  ************************/}
                                {section.subSections?.map(
                                  (subSection, subIdx) => {
                                    const uniqueSubId = `${index}-${subIdx}`;
                                    return (
                                      <Card
                                        key={subIdx}
                                        style={{ border: "1px solid #ced4da" }}
                                      >
                                        <Accordion
                                          flush
                                          open={openSubAccordion}
                                          toggle={() =>
                                            handleSubAccordion(uniqueSubId)
                                          }
                                        >
                                          <AccordionItem >
                                            <AccordionHeader
                                              targetId={uniqueSubId}
                                              style={{backgroundColor :'rgb(204 215 255)'}}
                                            >
                                              <div className="accordionSectionHeader">
                                              <span>{subSection.name}</span>
                                              <button type="button"
                                              onClick={(e)=>handleDeleteSection('SUB_SECTION', {index, subIdx})}
                                            >
                                              <span >
                                                <i class="bi bi-trash-fill"></i>
                                              </span>
                                            </button>
                                            </div>
                                              
                                            </AccordionHeader>
                                            <AccordionBody
                                              accordionId={uniqueSubId}
                                            >
                                              {/*<------------------------SUB SECTION fORM----------------------------->*/}
                                              <Row>
                                              {sectionItems[index]?.subSections?.[subIdx]?.productData && sectionItems[index]?.subSections?.[subIdx]?.productData?.length !==0 &&
                                                    <div>

                                                    <Row className="d-flex justify-content-end mb-2">
                                                      <Col md={3}>
                                                      <Input
                                                        type="text"
                                                        value={searchInput?.[index]?.subSections?.[subIdx]?.input || ""} // Access the specific input value for the index
                                                        placeholder="Search..."
                                                        name="search"
                                                        onChange={(e) => handleSectionWiseSearch(e.target.value, {index, subIdx}, "SUB_SECTION")}
                                                        className="rounded-3"
                                                      />
                                                      </Col>
                                                    </Row>
                                                      <div style={{ maxHeight: '200px', overflowY: 'auto',border: "1px solid #8ab1eb"}} className="mb-4">
                                                        <Table hover style={{ tableLayout: 'fixed', width: '100%', borderCollapse: 'collapse' }}>
                                                          <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 1 }}>
                                                            <tr className="table-secondary">
                                                              <th>S.No.</th>
                                                              <th>Product</th>
                                                              <th>Product Code</th>
                                                              <th>Part No</th>
                                                              <th>Actions</th>
                                                            </tr>
                                                          </thead>
                                                          <tbody>
                                                            {sectionItems[index]?.subSections?.[subIdx]?.filteredProductData?.map((item, itemIndex) => (
                                                              <tr key={itemIndex} className="table-primary">
                                                                <td>{itemIndex + 1}</td>
                                                                <td>{item?.product_name}</td>
                                                                <td>{item?.product_code}</td>
                                                                <td>{item?.part_number}</td>
                                                                <td>
                                                                  <Button type="button"
                                                                   onClick={(e)=>handleProductEdit(item, {index, subIdx}, 'SUB_SECTION')}
                                                                   >
                                                                    Edit <i className="bi bi-pencil-square"></i>
                                                                  </Button>
                                                                </td>
                                                              </tr>
                                                            ))}
                                                          </tbody>
                                                        </Table>
                                                      </div>

                                                    </div>
                                                    }
                                            {(isUpdateProductButtonSection[index]?.subSections?.[subIdx]) && <Row>
                                              <Col md={3}>
                                                <Button
                                                  className="mb-2"
                                                  color="success"
                                                  onClick={(e) =>
                                                    handleButtonAddNewProductInEdit(
                                                        {index , subIdx},
                                                        "SUB_SECTION"
                                                    )
                                                  }
                                                  >
                                                    Add new product
                                                  </Button>
                                              </Col>
                                            </Row>}

                                              <Col md={4}>
                                                <FormGroup>
                                                  <Label htmlFor="product">
                                                  {!sectionItems[index]?.subSections?.[subIdx]?.manufacture && <br />}
                                                    Search Product:
                                                  </Label>
                                                  <AsyncSelect 
                                                      defaultOptions 
                                                      cacheOptions
                                                      placeholder="Search..."
                                                      loadingMessage={() => "Loading..."}
                                                      loadOptions={loadProductOptions} 
                                                      onChange={(selectedOption) =>
                                                        handleProductSelectChange(
                                                          selectedOption,
                                                          { index, subIdx },
                                                            "SUB_SECTION"
                                                        )
                                                      }
                                                      value={
                                                        sectionItems[index]
                                                          ?.subSections?.[subIdx]
                                                          ?.product || []
                                                      } // Set default value to null if no product is selected
                                                    />
                          
                                                      {sectionItems[index]
                                                      ?.subSections?.[subIdx]
                                                      ?.errorMessages
                                                      ?.product && (
                                                      <div className="invalidError d-flex justify-content-center">
                                                        {
                                                          sectionItems[index]
                                                            ?.subSections?.[
                                                            subIdx
                                                          ]?.errorMessages
                                                            ?.product
                                                        }
                                                      </div>
                                                    )}
                                                </FormGroup>
                                              </Col>

                                                {/* #Manufacture */}
                                                {sectionItems[index]?.subSections?.[subIdx]?.manufacture && <Col md={2}>
                                                    <FormGroup>
                                                      <Label>Manufacture:</Label>
                                                        <Input
                                                          type="text"
                                                          value={sectionItems[index]?.subSections?.[subIdx]?.manufacture || ""}
                                                          readOnly={true}
                                                        />
                                                    </FormGroup>
                                                </Col>}
                                                  {/* #Initial GPL Price */}
                                                {sectionItems[index]?.subSections?.[subIdx]?.initial_gpl_price && <Col md={2}>
                                                    <FormGroup>
                                                      <Label>GPL:</Label>
                                                        <Input
                                                          type="text"
                                                          value={sectionItems[index]?.subSections?.[subIdx]?.initial_gpl_price || ""}
                                                          readOnly={true}
                                                        />
                                                    </FormGroup>
                                                </Col>}
           

                                                {/* Distributor */}
                                                {sectionItems[index]?.subSections?.[subIdx]?.manufacture &&<Col md={4}>
                                                  <FormGroup>
                                                    <Label htmlFor="distributor">
                                                      Select Distributor:
                                                    </Label>
                                                    <div className="d-flex">
                                                    <div style={{flexGrow : '1'}} className="me-2">
                                                    <Select
                                                      value={
                                                        sectionItems[index]?.subSections?.[subIdx]?.distributor || []
                                                      }
                                                      options={sectionItems[index]?.subSections?.[subIdx]?.distributorOptions}
                                                      placeholder="Select a distributor"
                                                      isSearchable
                                                      onChange={(selectedOption) =>
                                                        handleDistributorSelectChange(
                                                          selectedOption,
                                                          { index, subIdx },
                                                          "SUB_SECTION"
                                                        )
                                                      }
                                                    />
                                                    </div>
                                                    {!sectionItems[index]?.subSections?.[subIdx]?.noDistributor && <div className="d-flex align-items-center">
                                                    <Dropdown isOpen={distributorOptionDropdownInIsOpen} toggle={() =>handleDistributorSortOptionDropDown()} direction="down">
                                                      <DropdownToggle
                                                        caret
                                                        style={{
                                                          backgroundColor: "transparent",
                                                          border: "none",
                                                          boxShadow: "none",
                                                          padding: "0px",
                                                        }}
                                                      >
                                                        <i
                                                          style={{ fontSize: "x-large", color: "black" }}
                                                          className="bi bi-filter-circle"
                                                        ></i>
                                                      </DropdownToggle>
                                                      <DropdownMenu
                                                        style={{
                                                          border: "none",
                                                          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                                          right: 0, // Forces alignment to the left of the button
                                                        }}
                                                      >
                                                        <DropdownItem 
                                                          onClick={()=>handleDistributorSortOption('SUB_SECTION', {index, subIdx},'PRICE')} style={{ 
                                                            padding: "10px 20px", 
                                                            cursor: "pointer", 
                                                            background: sectionItems[index]?.subSections?.[subIdx]?.selectedSortOption === 'PRICE' ? "antiquewhite" : ""
                                                          }}>
                                                          Price
                                                        </DropdownItem>
                                                        <DropdownItem                            
                                                            onClick={()=>handleDistributorSortOption('SUB_SECTION', {index, subIdx},'LEAD_TIME')} style={{ 
                                                            padding: "10px 20px", 
                                                            cursor: "pointer", 
                                                            background: sectionItems[index]?.subSections?.[subIdx]?.selectedSortOption === 'LEAD_TIME' ? "antiquewhite" : ""
                                                          }}>
                                                          Lead time
                                                        </DropdownItem>
                                                      </DropdownMenu>
                                                    </Dropdown>
                                                  </div>}
                                                   </div>

                                                    {sectionItems[index]?.subSections?.[subIdx]?.errorMessages
                                                      ?.distributor && (
                                                      <div className="invalidError d-flex justify-content-center">
                                                        {
                                                          sectionItems[index]?.subSections?.[subIdx]?.errorMessages
                                                            ?.distributor
                                                        }
                                                      </div>
                                                    )}
                                                  </FormGroup>
                                                </Col>}

                                                {/* GPL */}
                                                {sectionItems[index]?.subSections?.[subIdx]?.noDistributor  && <Col md={6}>
                                                    <FormGroup>
                                                    <Label>
                                                        Manufacture Price <br />
                                                        (includes Logistic Fee:{" "}
                                                        <span style={{ color: "red" }}>
                                                        {sectionItems[index]?.subSections?.[subIdx]?.shipmentCharge || "0.00"}
                                                        </span>, 
                                                        Markup Fee:{" "}
                                                        <span style={{ color: "red" }}>
                                                        {sectionItems[index]?.subSections?.[subIdx]?.markupFee || "0.00"}
                                                        </span>)
                                                      </Label>
                                                        <Input
                                                          type="number"
                                                          value={sectionItems[index]?.subSections?.[subIdx]?.distributor_price_with_markup || ""}
                                                          onChange={(e) =>{
                                                            const value = e.target.value;
                                                            handleDistributorPriceChange(
                                                              value,
                                                              {index, subIdx },
                                                              "SUB_SECTION"
                                                              )
                                                          }}
                                                        />
                                                    </FormGroup>
                                                </Col>}
                                                {/* Distributor with markup*/}
                                                {!sectionItems[index]?.subSections?.[subIdx]?.noDistributor  &&<Col md={6}>
                                                  <FormGroup>
                                                    <Label>
                                                        Distributor Price <br />
                                                        (includes Logistic Fee:{" "}
                                                        <span style={{ color: "red" }}>
                                                        {sectionItems[index]?.subSections?.[subIdx]?.shipmentCharge || "0.00"}
                                                        </span>, 
                                                        Markup Fee:{" "}
                                                        <span style={{ color: "red" }}>
                                                        {sectionItems[index]?.subSections?.[subIdx]?.markupFee || "0.00"}
                                                        </span>)
                                                      </Label>
                                                      <Input
                                                        type="number"
                                                        value={sectionItems[index]?.subSections?.[subIdx]?.distributor_price_with_markup || ""}
                                                        onChange={(e) =>{
                                                          const value = e.target.value;
                                                          handleDistributorPriceChange(
                                                            value,
                                                            {index, subIdx },
                                                            "SUB_SECTION"
                                                            )
                                                        }}
                                                      />
                                                  </FormGroup>
                                                </Col>}

                                                {/* Markup */}
                                                <Col md={4}>
                                                    <FormGroup>
                                                      {sectionItems[index]?.subSections[subIdx]?.distributor_price_with_markup &&  <br />} 
                                                      <Label>Standard Markup (%):</Label>
                                                        <Input
                                                          type="number"
                                                          value={sectionItems[index]?.subSections[subIdx]?.standard_markup || ""}
                                                          id="standard_markup"
                                                          name="standard_markup"
                                                          onChange={(e) =>
                                                            handleStandardMarkupChange(
                                                              e.target.value,
                                                              {index, subIdx },
                                                              "SUB_SECTION"
                                                            )
                                                          }
                                                        />
                                                    </FormGroup>
                                                </Col>

                                                {/* PRICING POLICY */}
                                                {sectionItems[index]?.subSections?.[subIdx]?.manufacture && <Col md={12}>
                                                    <Form>
                                                      <FormGroup>
                                                        <Label style={{ color: 'red' }}>Pricing Policy:</Label>
                                                        <div className="d-flex gap-5">
                                                          <FormGroup check>
                                                            <Label check>
                                                              <Input
                                                                type="radio"
                                                                name="radioOption"
                                                                value={pricingPolicy.standard_pricing.value}
                                                                checked={sectionItems[index]?.subSections?.[subIdx]?.pricingPolicyOption === pricingPolicy.standard_pricing.value}
                                                                onChange={(e) =>
                                                                  handlePricePolicyChange(
                                                                    pricingPolicy.standard_pricing.value,
                                                                    {index, subIdx },
                                                                    "SUB_SECTION"
                                                                  )
                                                                }

                                                              />
                                                              {pricingPolicy.standard_pricing.label}
                                                            </Label>
                                                          </FormGroup>
                                                          {!sectionItems[index]?.subSections?.[subIdx].noDistributor && <FormGroup check>
                                                            <Label check>
                                                              <Input
                                                                type="radio"
                                                                name="radioOption"
                                                                value={pricingPolicy.distributor_discount.value}
                                                                checked={sectionItems[index]?.subSections?.[subIdx]?.pricingPolicyOption === pricingPolicy.distributor_discount.value}
                                                                onChange={(e) =>
                                                                  handlePricePolicyChange(
                                                                    pricingPolicy.distributor_discount.value,
                                                                    {index, subIdx },
                                                                    "SUB_SECTION"
                                                                  )
                                                                }
                                                              />
                                                              {pricingPolicy.distributor_discount.label}
                                                            </Label>
                                                          </FormGroup>}
                                                          <FormGroup check>
                                                            <Label check>
                                                              <Input
                                                                type="radio"
                                                                name="radioOption"
                                                                value={pricingPolicy.manufacture_discount.value}
                                                                checked={sectionItems[index]?.subSections?.[subIdx]?.pricingPolicyOption === pricingPolicy.manufacture_discount.value}
                                                                onChange={(e) =>
                                                                  handlePricePolicyChange(
                                                                    pricingPolicy.manufacture_discount.value,
                                                                    {index, subIdx },
                                                                    "SUB_SECTION"
                                                                  )
                                                                }
                                                              />
                                                              {pricingPolicy.manufacture_discount.label}
                                                            </Label>
                                                          </FormGroup>
                                                        </div>
                                                      </FormGroup>
                                                      {/* <p>Selected Option: {selectedOption}</p> */}
                                                    </Form>
                                                </Col>}   

                                                {/* Unit type */}
                                                <Col md={2}>
                                                  <FormGroup>
                                                    <Label htmlFor="unit_type">
                                                      Unit type:
                                                    </Label>

                                                    <select
                                                      id="unit_type"
                                                      value={
                                                        sectionItems[index]
                                                          ?.subSections?.[subIdx]
                                                          ?.unit_type || []
                                                      }
                                                      defaultValue={'Ea'}
                                                      name="unit_type"
                                                      className="selectInput me-2"
                                                      onChange={(e) =>
                                                        handleUnitTypeChange(
                                                          e.target.value,
                                                          { index, subIdx },
                                                          "SUB_SECTION"
                                                        )
                                                      }
                                                    >
                                                      <option value="">
                                                        Select type
                                                      </option>
                                                      {unitTypes.map((item) => (
                                                        <option value={item.value}>
                                                          {item.name}
                                                        </option>
                                                      ))}
                                                    </select>
                                                    {sectionItems[index]
                                                      ?.subSections?.[subIdx]
                                                      ?.errorMessages
                                                      ?.unit_type && (
                                                      <div className="invalidError d-flex justify-content-center">
                                                        {
                                                          sectionItems[index]
                                                            ?.subSections?.[
                                                            subIdx
                                                          ]?.errorMessages
                                                            ?.unit_type
                                                        }
                                                      </div>
                                                    )}
                                                  </FormGroup>
                                                </Col>
                                              
                                                {/* Quantity */}
                                                <Col md={2}>
                                                  <FormGroup>
                                                    <Label htmlFor={`sub_quantity${uniqueSubId}`}>
                                                      Quantity:
                                                    </Label>
                                                    <Input
                                                      type="number"
                                                      aria-invalid={Boolean(sectionItems[index]?.subSections?.[subIdx]?.errorMessages?.quantity)}
                                                      value={
                                                        sectionItems[index]
                                                          ?.subSections?.[subIdx]
                                                          ?.quantity || []
                                                      }
                                                      onChange={(e) =>{
                                                        const value = e.target.value;
                                                       
                                                          handleQuantityChange(
                                                            sectionItems[index]?.subSections?.[subIdx]?.pricingPolicyOption,
                                                            value,
                                                            { index, subIdx },
                                                            "SUB_SECTION"
                                                          )
                                                        
                                                      }
                                                      }
                                                      id={`sub_quantity${uniqueSubId}`}
                                                      name={`sub_quantity${uniqueSubId}`}
                                                    />
                                                    {sectionItems[index]
                                                      ?.subSections?.[subIdx]
                                                      ?.errorMessages
                                                      ?.quantity && (
                                                      <div className="invalidError d-flex justify-content-center">
                                                        {
                                                          sectionItems[index]
                                                            ?.subSections?.[
                                                            subIdx
                                                          ]?.errorMessages
                                                            ?.quantity
                                                        }
                                                      </div>
                                                    )}
                                                  </FormGroup>
                                                </Col>

                                                {/* Discount */}
                                                {sectionItems[index]?.subSections?.[subIdx]?.pricingPolicyOption !== pricingPolicy.standard_pricing.value && <Col md={2}>
                                                  <FormGroup>
                                                    <Label htmlFor="sub_policy_discount">Discount (%):</Label>
                                                    <Input
                                                      type="number"
                                                      value={sectionItems[index]?.subSections?.[subIdx]?.pricing_policy_discount?.value || '0'}
                                                      onChange={(e) =>{
                                                        const value = e.target.value;
                                                  
                                                          handlePricingPolicyDiscountChange(
                                                            sectionItems[index]?.subSections?.[subIdx]?.pricingPolicyOption,
                                                            value,
                                                            { index, subIdx },
                                                            "SUB_SECTION"
                                                          )
                                                        
                                                      }
                                                      }
                                                      id="pricing_policy_discount"
                                                      name="pricing_policy_discount"
                                                    />
                                                  </FormGroup>
                                                </Col>}

                                                {/* Markup+price*qty */}
                                                <Col md={3}>
                                                    <FormGroup>
                                                      <Label>Total Price:</Label>
                                                        <Input
                                                          type="text"
                                                          value={sectionItems[index]?.subSections?.[subIdx]?.markup_total_price || ""}
                                                          onChange={(e) =>{
                                                            const value = e.target.value;
                                                            handleTotalPriceChange(
                                                                value,
                                                                { index, subIdx },
                                                                "SUB_SECTION"
                                                              )
                                                          }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Row className="d-flex  justify-content-end mb-4">
                                                  <Col md={4} className="d-flex  justify-content-end">
                                                    <FormGroup
                                                      style={{
                                                        position: "relative",
                                                        top: "28px",
                                                        right: "15px",
                                                      }}
                                                    >
                                                      <Button
                                                        color={`${isUpdateProductButtonSection[index]?.subSections?.[subIdx] ?  'danger' : 'success'} me-3`}
                                                        // color={`success me-3`}

                                                        onClick={(e) =>
                                                          addProductToSection(
                                                            { index, subIdx },
                                                            "SUB_SECTION"
                                                          )
                                                        }
                                                      >

                                                        {isUpdateProductButtonSection[index]?.subSections?.[subIdx] ? 'Update product' : 'Add product'}
                                                      </Button>
                                                      {sectionBaseSavedProducts[index]?.subSections[subIdx] && sectionBaseSavedProducts[index]?.subSections[subIdx].length !==0 && <Button
                                                        color="info"
                                                        onClick={(e)=>handleShowViewModal({index, subIdx}, 'SUB_SECTION')}
                                                      >
                                                        View products
                                                      </Button>}
                                                    </FormGroup>
                                                  </Col>
                                                </Row>
                                           

                                                {/* Final Price*/}
                                                <Row className="d-flex justify-content-end">
                                                  <Col md={3} className="d-flex justify-content-end mt-3">
                                                      <Label>Final Price: <span style={{color : 'red', fontSize : '18px'}}>{sectionTotalProductFinalPrice?.[index]?.subSection?.[subIdx]?.finalPrice.toFixed(2) || 0}</span></Label>
                                                  </Col>
                                                </Row>
                                              </Row>
                                            </AccordionBody>
                                          </AccordionItem>
                                        </Accordion>
                                      </Card>
                                    );
                                  }
                                )}

                                {/*<------------------------MAIN SECTION fORM----------------------------->*/}
                                <Row>

                                  { sectionItems[index]?.productData && sectionItems[index]?.productData?.length !==0 &&
                                      <div>

                                        <Row className="d-flex justify-content-end mb-2">
                                        <Col md={3}>
                                        <Input
                                          type="text"
                                          value={searchInput?.[index]?.input || ""} // Access the specific input value for the index
                                          placeholder="Search..."
                                          name="search"
                                          onChange={(e) => handleSectionWiseSearch(e.target.value, index, "MAIN_SECTION")}
                                          className="rounded-3"
                                        />
                                        </Col>
                                      </Row>
                                        <div style={{ maxHeight: '200px', overflowY: 'auto',border: "1px solid #8ab1eb"}} className="mb-4">
                                          <Table hover style={{ tableLayout: 'fixed', width: '100%', borderCollapse: 'collapse' ,  }}>
                                            <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 1 }}>
                                              <tr className="table-secondary">
                                                <th>S.No.</th>
                                                <th>Product</th>
                                                <th>Product Code</th>
                                                <th>Part No</th>
                                                <th>Actions</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {sectionItems?.[index]?.filteredProductData?.map((item, itemIndex) => (
                                                <tr key={itemIndex} className="table-primary">
                                                  <td>{itemIndex + 1}</td>
                                                  <td>{item?.product_name}</td>
                                                  <td>{item?.product_code}</td>
                                                  <td>{item?.part_number}</td>
                                                  <td>
                                                    <Button type="button"
                                                     onClick={(e)=>handleProductEdit(item, index, 'MAIN_SECTION')}
                                                     >
                                                      Edit <i className="bi bi-pencil-square"></i>
                                                    </Button>
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </Table>
                                        </div>

                                      </div>
                                  }
                                {(isUpdateProductButtonSection[index]?.[index]) && <Row>
                                  <Col md={3}>
                                    <Button
                                      className="mb-2"
                                      color="success"
                                      onClick={(e) =>
                                        handleButtonAddNewProductInEdit(
                                            index,
                                            "MAIN_SECTION"
                                        )
                                      }
                                      >
                                        Add new product
                                      </Button>
                                  </Col>
                                </Row>}
                                  {/* #Products */}
                                  <Col md={4}>
                                    <FormGroup>
                                      <Label htmlFor="product">
                                      {!sectionItems?.[index].manufacture && <br />}
                                        Search Product:
                                      </Label>
                                      <AsyncSelect 
                                          defaultOptions 
                                          cacheOptions
                                          placeholder="Search..."
                                          loadingMessage={() => "Loading..."}
                                          loadOptions={loadProductOptions} 
                                          onChange={(selectedOption) =>
                                            handleProductSelectChange(
                                              selectedOption,
                                              index,
                                              "MAIN_SECTION"
                                            )
                                          }
                                          value={sectionItems?.[index]?.product || null} // Set default value to null if no product is selected
                                        />
              
                                      {sectionItems[index]?.errorMessages
                                        ?.product && (
                                        <div className="invalidError d-flex justify-content-center">
                                          {
                                            sectionItems[index]?.errorMessages
                                              ?.product
                                          }
                                        </div>
                                      )}
                                    </FormGroup>
                                  </Col>

                                  {/* #Manufacture */}
                                  {sectionItems[index]?.manufacture && <Col md={2}>
                                      <FormGroup>
                                        <Label>Manufacture:</Label>
                                          <Input
                                            type="text"
                                            value={sectionItems[index]?.manufacture || ""}
                                            readOnly={true}
                                          />
                                      </FormGroup>
                                  </Col>}

                                  {/* #Initial GPL Price */}
                                  {sectionItems[index]?.initial_gpl_price && <Col md={2}>
                                      <FormGroup>
                                        <Label>GPL:</Label>
                                          <Input
                                            type="text"
                                            value={sectionItems[index]?.initial_gpl_price || ""}
                                            readOnly={true}
                                          />
                                      </FormGroup>
                                  </Col>}



                                                
                                  {/* Distributor */}
                                  {sectionItems[index]?.manufacture &&<Col md={4}>
                                    <FormGroup>
                                      <Label htmlFor="distributor">
                                        Select Distributor:
                                      </Label>
                                      <div className="d-flex">
                                          <div style={{flexGrow : '1'}} className="me-2">
                                          <Select
                                            value={
                                              sectionItems[index]?.distributor || []
                                            }
                                            options={sectionItems[index]?.distributorOptions}
                                            placeholder="Select a distributor"
                                            isSearchable
                                            onChange={(selectedOption) =>
                                              handleDistributorSelectChange(
                                                selectedOption,
                                                index,
                                                "MAIN_SECTION"
                                              )
                                            }
                                          />
                                          </div>
                                          {!sectionItems[index]?.noDistributor && 
                                          <div className="d-flex align-items-center">
                                              <Dropdown isOpen={distributorOptionDropdownInIsOpen} toggle={() =>handleDistributorSortOptionDropDown()} direction="down">
                                                <DropdownToggle
                                                  caret
                                                  style={{
                                                    backgroundColor: "transparent",
                                                    border: "none",
                                                    boxShadow: "none",
                                                    padding: "0px",
                                                  }}
                                                >
                                                  <i
                                                    style={{ fontSize: "x-large", color: "black" }}
                                                    className="bi bi-filter-circle"
                                                  ></i>
                                                </DropdownToggle>
                                                <DropdownMenu
                                                  style={{
                                                    border: "none",
                                                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                                    right: 0, // Forces alignment to the left of the button
                                                  }}
                                                >
                                                  <DropdownItem 
                                                  			onClick={()=>handleDistributorSortOption('MAIN_SECTION', index,'PRICE')} style={{ 
                                                          padding: "10px 20px", 
                                                          cursor: "pointer", 
                                                          background: sectionItems[index]?.selectedSortOption === 'PRICE' ? "antiquewhite" : ""
                                                        }}>
                                                    Price
                                                  </DropdownItem>
                                                  <DropdownItem 
                                                      onClick={()=>handleDistributorSortOption('MAIN_SECTION', index,'LEAD_TIME')} style={{ 
                                                        padding: "10px 20px", 
                                                        cursor: "pointer", 
                                                        background: sectionItems[index]?.selectedSortOption === 'LEAD_TIME' ? "antiquewhite" : ""
                                                      }}>
                                                    Lead time
                                                  </DropdownItem>
                                                </DropdownMenu>
                                              </Dropdown>
                                          </div>}
                                      </div>
                                      {sectionItems[index]?.errorMessages
                                        ?.distributor && (
                                        <div className="invalidError d-flex justify-content-center">
                                          {
                                            sectionItems[index]?.errorMessages
                                              ?.distributor
                                          }
                                        </div>
                                      )}
                                    </FormGroup>
                                  </Col>}

                                  {/* #GPL Price + Logistic fee + standard tax*/}
                                  { sectionItems[index]?.noDistributor && <Col md={6}>
                                          <FormGroup>
                                        <Label>
                                            Manufacture Price <br />
                                            (includes Logistic Fee:{" "}
                                            <span style={{ color: "red" }}>
                                            {sectionItems[index]?.shipmentCharge || "0.00"}
                                            </span>, 
                                            Markup Fee:{" "}
                                            <span style={{ color: "red" }}>
                                            {sectionItems[index]?.markupFee || "0.00"}
                                            </span>)
                                          </Label>
                                          <Input
                                            type="number"
                                            value={sectionItems[index].distributor_price_with_markup || ""}
                                            onChange={(e) =>{
                                              const value = e.target.value;
                                              handleDistributorPriceChange(
                                                value,
                                                index,
                                                "MAIN_SECTION"
                                                )
                                            }}
                                          />
                                      </FormGroup>
                                  </Col>}
                                  {/* Distributor with markup*/}
                                  { !sectionItems[index]?.noDistributor  &&<Col md={6}>
                                    <FormGroup>
                                          <Label>
                                            Distributor Price <br />
                                            (includes Logistic Fee:{" "}
                                            <span style={{ color: "red" }}>
                                              {sectionItems[index]?.shipmentCharge || "0.00"}
                                            </span>, 
                                            Markup Fee:{" "}
                                            <span style={{ color: "red" }}>
                                              {sectionItems[index]?.markupFee || "0.00"}
                                            </span>)
                                        </Label>
                                          <Input
                                            type="number"
                                            value={sectionItems[index]?.distributor_price_with_markup || ""}
                                            onChange={(e) =>{
                                              const value = e.target.value;
                                              handleDistributorPriceChange(
                                                value,
                                                index,
                                                "MAIN_SECTION"
                                                )
                                            }}
                                          />
                                    </FormGroup>
                                  </Col>}
                                  
                                  {/* Markup */}
                                  <Col md={4}>
                                      <FormGroup>
                                      {sectionItems[index]?.distributor_price_with_markup &&  <br />}
                                        <Label>Standard Markup (%):</Label>
                                          <Input
                                            type="number"
                                            value={sectionItems[index]?.standard_markup || ""}
                                            id="standard markup"
                                            name="standard_markup"
                                            onChange={(e) =>
                                              handleStandardMarkupChange(
                                                e.target.value,
                                                index,
                                                "MAIN_SECTION"
                                              )
                                            }
                                          />
                                      </FormGroup>
                                  </Col>

                                  {/* PRICING POLICY */}
                                  {sectionItems[index]?.manufacture && <Col md={12}>
                                      <Form>
                                        <FormGroup>
                                          <Label style={{ color: 'red' }}>Pricing Policy:</Label>
                                          <div className="d-flex gap-5">
                                            <FormGroup check>
                                              <Label check>
                                                <Input
                                                  type="radio"
                                                  name="radioOption"
                                                  value={pricingPolicy.standard_pricing.value}
                                                  checked={sectionItems[index]?.pricingPolicyOption === pricingPolicy.standard_pricing.value}
                                                  onChange={(e) =>
                                                    handlePricePolicyChange(
                                                    pricingPolicy.standard_pricing.value,
                                                    index,
                                                    "MAIN_SECTION"
                                                    )
                                                  }
                                                />
                                                {pricingPolicy.standard_pricing.label}
                                              </Label>
                                            </FormGroup>
                                            {!sectionItems[index]?.noDistributor  && <FormGroup check>
                                              <Label check>
                                                <Input
                                                  type="radio"
                                                  name="radioOption"
                                                  value={pricingPolicy.distributor_discount.value}
                                                  checked={sectionItems[index]?.pricingPolicyOption === pricingPolicy.distributor_discount.value}
                                                  onChange={(e) =>
                                                    handlePricePolicyChange(
                                                        pricingPolicy.distributor_discount.value,
                                                        index,
                                                        "MAIN_SECTION"
                                                    )
                                                  }
                                                />
                                                {pricingPolicy.distributor_discount.label}
                                              </Label>
                                            </FormGroup>}
                                            <FormGroup check>
                                              <Label check>
                                                <Input
                                                  type="radio"
                                                  name="radioOption"
                                                  value={pricingPolicy.manufacture_discount.value}
                                                  checked={sectionItems[index]?.pricingPolicyOption === pricingPolicy.manufacture_discount.value}
                                                  onChange={(e) =>
                                                    handlePricePolicyChange(
                                                        pricingPolicy.manufacture_discount.value,
                                                        index,
                                                        "MAIN_SECTION"
                                                    )
                                                  }
                                                />
                                                {pricingPolicy.manufacture_discount.label}
                                              </Label>
                                            </FormGroup>
                                          </div>
                                        </FormGroup>
                                        {/* <p>Selected Option: {selectedOption}</p> */}
                                      </Form>
                                  </Col>}   

                                  {/* Unit type */}
                                  <Col md={2}>
                                    <FormGroup>
                                      <Label htmlFor="unit_type">Unit type:</Label>

                                      <select
                                        id="unit_type"
                                        value={sectionItems[index]?.unit_type}
                                        name="unit_type"
                                        className="selectInput me-2"
                                        onChange={(e) =>
                                          handleUnitTypeChange(
                                            e.target.value,
                                            index,
                                            "MAIN_SECTION"
                                          )
                                        }
                                      >
                                        <option value="">Select type</option>
                                        {unitTypes.map((item) => (
                                          <option value={item.value}>
                                            {item.name}
                                          </option>
                                        ))}
                                      </select>
                                      {sectionItems[index]?.errorMessages
                                        ?.unit_type && (
                                        <div className="invalidError d-flex justify-content-center">
                                          {
                                            sectionItems[index]?.errorMessages
                                              ?.unit_type
                                          }
                                        </div>
                                      )}
                                    </FormGroup>
                                  </Col>

                                  {/* Quantity */}
                                  <Col md={2}>
                                    <FormGroup>
                                      <Label htmlFor="main_quantity">Quantity:</Label>
                                      <Input
                                        type="number"
                                        value={sectionItems[index]?.quantity}

                                        onChange={(e) =>{
                                          const value = e.target.value;
                                            handleQuantityChange(
                                              sectionItems[index]?.pricingPolicyOption,
                                              value,
                                              index,
                                              "MAIN_SECTION"
                                            )
                                        }
                                        }
                                        id="quantity"
                                        name="quantity"
                                      />
                                      {sectionItems[index]?.errorMessages
                                        ?.quantity && (
                                        <div className="invalidError d-flex justify-content-center">
                                          {
                                            sectionItems[index]?.errorMessages
                                              ?.quantity
                                          }
                                        </div>
                                      )}
                                    </FormGroup>
                                  </Col>

                                  {/* Discount */}
                                  {sectionItems[index]?.pricingPolicyOption !== pricingPolicy.standard_pricing.value && <Col md={2}>
                                    <FormGroup>
                                      <Label htmlFor="main_policy_discount">Discount (%):</Label>
                                      <Input
                                        type="number"
                                        value={sectionItems[index]?.pricing_policy_discount?.value || '0'}
                                        onChange={(e) =>{
                                          const value = e.target.value;
                                    
                                            handlePricingPolicyDiscountChange(
                                              sectionItems[index]?.pricingPolicyOption ,
                                              value,
                                              index,
                                              "MAIN_SECTION"
                                            )
                                          
                                        }
                                        }
                                        id="pricing_policy_discount"
                                        name="pricing_policy_discount"
                                      />
                                    </FormGroup>
                                  </Col>}

                                  {/* Markup+price*qty */}
                                  <Col md={3}>
                                      <FormGroup>
                                        <Label>Total Price:</Label>
                                          <Input
                                            type="text"
                                            value={sectionItems[index]?.markup_total_price || ""}
                                            onChange={(e) =>{
                                              const value = e.target.value;
                                              handleTotalPriceChange(
                                                  value,
                                                  index,
                                                  "MAIN_SECTION"
                                                )
                                            }}
                                          />
                                      </FormGroup>
                                  </Col>
                                  <Row className="d-flex  justify-content-end mb-4">
                                      <Col md={4} className="d-flex  justify-content-end">
                                          <FormGroup
                                    style={{
                                      position: "relative",
                                      top: "28px",
                                      right: "15px",
                                    }}
                                  >
                                    <Button
                                      color={`${Boolean(isUpdateProductButtonSection[index]?.[index])?  'danger' : 'success'} me-3`}
                                      onClick={(e) =>
                                        addProductToSection(
                                          index,
                                          "MAIN_SECTION"
                                        )
                                      }
                                    >
                                        {Boolean(isUpdateProductButtonSection[index]?.[index])  ? 'Update product' :  'Add product'}
                                    </Button>

                                    {sectionBaseSavedProducts[index]?.products && sectionBaseSavedProducts[index]?.products.length !==0 && <Button
                                      color="info"
                                      onClick={(e)=>handleShowViewModal(index, 'MAIN_SECTION')}
                                    >
                                      View products
                                    </Button>}
                                          </FormGroup>
                                      </Col>
                                  </Row>


                                  {/* Final Price*/}
                                  <Row className="d-flex justify-content-end">
                                    <Col md={3} className="d-flex justify-content-end mt-3">
                                        <Label>Final Price: <span style={{color : 'red', fontSize : '18px'}}>{sectionTotalProductFinalPrice?.[index]?.finalPrice?.toFixed(2) || 0}</span></Label>
                                    </Col>
                                  </Row>
                                </Row>
                              </AccordionBody>
                            </AccordionItem>
                          ))}
                        </Accordion>
                      </Card>
                    )}
                  </Col>
                </>}  
                {/* <-------------------------NOT SECTION------------------------------> */}
                {!isSectionActive && <>

                  {selectedProduct?.productData && selectedProduct?.productData?.length !==0 &&
                      <div>

                        <Row className="d-flex justify-content-end mb-2">
                        <Col md={3}>
                          <Input
                            type="text"
                            value={searchInput}
                            placeholder="Search..."
                            name="search"
                            onChange={(e) => handleSectionWiseSearch(e.target.value, '', "NO_SECTION")}
                            className="rounded-3"
                          />
                        </Col>
                      </Row>
                        <div style={{ maxHeight: '200px', overflowY: 'auto' ,border: "1px solid #8ab1eb"}} className="mb-4">
                          <Table hover style={{ tableLayout: 'fixed', width: '100%', borderCollapse: 'collapse' }}>
                            <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 1 }}>
                              <tr className="table-secondary">
                                <th>S.No.</th>
                                <th>Product</th>
                                <th>Product Code</th>
                                <th>Part No</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedProduct?.filteredProductData?.map((item, index) => (
                                <tr key={index} className="table-primary">
                                  <td>{index + 1}</td>
                                  <td>{item?.product_name}</td>
                                  <td>{item?.product_code}</td>
                                  <td>{item?.part_number}</td>
                                  <td>
                                    <Button type="button" onClick={(e)=>handleProductEdit(item, '', 'NO_SECTION')}>
                                      Edit <i className="bi bi-pencil-square"></i>
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>

                      </div>
                  }
                    {selectedProduct?.productData?.length !==0 && !isUpdateProductButtonNoSection  && <Row>
                      <Col md={3}>
                         <Button
                          className="mb-2"
                          color="success"
                          onClick={(e) =>
                            handleButtonAddNewProductInEdit(
                              '',
                              "NO_SECTION"
                            )
                          }
                          >
                            Add new product
                          </Button>
                      </Col>
                    </Row>}
                    <Row>
                      {/* #Products */}
                      <Col md={4}>
                        <FormGroup>
                          {!selectedProduct?.manufacture && <br />}
                          <Label htmlFor="product">
                            Search Product:
                          </Label>
                          <AsyncSelect 
                              defaultOptions 
                              cacheOptions
                              placeholder="Search..."
                              loadingMessage={() => "Loading..."}
                              loadOptions={loadProductOptions} 
                              onChange={(selectedOption) =>
                                handleProductSelectChange(
                                  selectedOption,
                                  '',
                                  "NO_SECTION"
                                )
                              }
                              value={selectedProduct} // Set default value to null if no product is selected
                            />

                          {noSectionFormInputErrorMessage
                            ?.product && (
                            <div className="invalidError d-flex justify-content-center">
                              {
                                noSectionFormInputErrorMessage
                                  ?.product
                              }
                            </div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* #Manufacture */}
                      {selectedProduct?.manufacture && <Col md={2}>
                          <FormGroup>
                            <Label>Manufacture:</Label>
                              <Input
                                type="text"
                                value={selectedProduct?.manufacture || ""}
                                readOnly={true}
                              />
                          </FormGroup>
                      </Col>}
                      

                      {/* #Initial GPL Price */}
                      {selectedProduct?.initial_gpl_price && <Col md={2}>
                          <FormGroup>
                            <Label>GPL:</Label>
                              <Input
                                type="text"
                                value={selectedProduct?.initial_gpl_price || ""}
                                readOnly={true}
                              />
                          </FormGroup>
                      </Col>}




                                    
                      {/* Distributor */}
                      {selectedProduct?.manufacture  &&<Col md={4}>
                        <FormGroup>
                          <Label htmlFor="distributor">
                            Select Distributor:
                          </Label>
                          <div className="d-flex">
                            <div style={{flexGrow : '1'}} className="me-2">
                              <Select
                                value={
                                  selectedProduct.distributor || {}
                                }
                                options={selectedProduct?.distributorOptions}
                                placeholder="Select a distributor"
                                isSearchable
                                onChange={(selectedOption) =>
                                  handleDistributorSelectChange(
                                    selectedOption,
                                    '',
                                    "NO_SECTION"
                                  )
                                }
                            />
                            </div>
                         
                           {!selectedProduct?.noDistributor && <div className="d-flex align-items-center">
                            <Dropdown isOpen={distributorOptionDropdownInIsOpen} toggle={() =>handleDistributorSortOptionDropDown()} direction="down">
                              <DropdownToggle
                                caret
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                  boxShadow: "none",
                                  padding: "0px",
                                }}
                              >
                                <i
                                  style={{ fontSize: "x-large", color: "black" }}
                                  className="bi bi-filter-circle"
                                ></i>
                              </DropdownToggle>
                              <DropdownMenu
                                style={{
                                  border: "none",
                                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                  right: 0, // Forces alignment to the left of the button
                                }}
                              >
                                <DropdownItem onClick={()=>handleDistributorSortOption('NO_SECTION','','PRICE')} style={{ 
                                    padding: "10px 20px", 
                                    cursor: "pointer", 
                                    background: selectedProduct.selectedSortOption === 'PRICE' ? "antiquewhite" : ""
                                  }}>
                                  Price
                                </DropdownItem>
                                <DropdownItem onClick={()=>handleDistributorSortOption('NO_SECTION','','LEAD_TIME')}  
                                    style={{ 
                                      padding: "10px 20px", 
                                      cursor: "pointer", 
                                      background: selectedProduct.selectedSortOption === 'LEAD_TIME' ? "antiquewhite" : ""
                                    }}>
                                  Lead time
                                </DropdownItem>
                              </DropdownMenu>
                            </Dropdown>
                           </div>}

                          </div>
                          
                          {noSectionFormInputErrorMessage
                            ?.distributor && (
                            <div className="invalidError d-flex justify-content-center">
                              {
                                noSectionFormInputErrorMessage
                                ?.distributor
                              }
                            </div>
                          )}
                        </FormGroup>
                      </Col>}

                      
                      {/* #GPL Price */}
                      { selectedProduct?.noDistributor && selectedProduct.distributor_price_with_markup && <Col md={6}>
                          <FormGroup>
                            <Label>
                                Manufacture Price <br />
                                (includes Logistic Fee:{" "}
                                <span style={{ color: "red" }}>
                                  {selectedProduct?.shipmentCharge || "0.00"}
                                </span>, 
                                Markup Fee:{" "}
                                <span style={{ color: "red" }}>
                                  {selectedProduct?.markupFee || "0.00"}
                                </span>)
                              </Label>
                              <Input
                                type="number"
                                value={selectedProduct.distributor_price_with_markup || ""}
                                onChange={(e) =>{
                                  const value = e.target.value;
                                  handleDistributorPriceChange(
                                    value,
                                    '',
                                    "NO_SECTION"
                                    )
                                }}
                              />
                          </FormGroup>
                      </Col>}

                      {/* Distributor With Markup */}
                      {!selectedProduct?.noDistributor && (
                        <Col md={6}>
                          <FormGroup>
                            <Label>
                              Distributor Price <br />
                              (includes Logistic Fee:{" "}
                              <span style={{ color: "red" }}>
                                {selectedProduct?.shipmentCharge || "0.00"}
                              </span>, 
                              Markup Fee:{" "}
                              <span style={{ color: "red" }}>
                                {selectedProduct?.markupFee || "0.00"}
                              </span>)
                            </Label>
                            <Input
                              type="number"
                              value={selectedProduct?.distributor_price_with_markup || ""}
                              onChange={(e) =>{
                                const value = e.target.value;
                                handleDistributorPriceChange(
                                  value,
                                  '',
                                  "NO_SECTION"
                                  )
                              }}
                            />
                          </FormGroup>
                        </Col>
                      )}


                      {/* Markup */}
                      <Col md={4}>
                          <FormGroup>
                            {selectedProduct?.distributor_price_with_markup &&  <br />}
                            <Label>Standard Markup (%):</Label>
                            <Input
                              type="number"
                              value={selectedProduct?.standard_markup || ""}
                              id="standard markup"
                              name="standard_markup"
                              onChange={(e) =>
                                handleStandardMarkupChange(
                                  e.target.value,
                                  '',
                                  "NO_SECTION"
                                )
                              }
                            />
                          </FormGroup>
                      </Col>

                      {/* PRICING POLICY */}
                      {selectedProduct?.manufacture && <Col md={12}>
                          <Form>
                            <FormGroup>
                              <Label style={{ color: 'red' }}>Pricing Policy:</Label>
                              <div className="d-flex gap-5">
                                <FormGroup check>
                                  <Label check>
                                    <Input
                                      type="radio"
                                      name="radioOption"
                                      value={pricingPolicy.standard_pricing.value}
                                      checked={selectedProduct.pricingPolicyOption === pricingPolicy.standard_pricing.value}
                                      onChange={(e) =>
                                        handlePricePolicyChange(
                                            pricingPolicy.standard_pricing.value,
                                            '',
                                            "NO_SECTION"
                                        )
                                      }
                                    />
                                    {pricingPolicy.standard_pricing.label}
                                  </Label>
                                </FormGroup>
                                {!selectedProduct?.noDistributor &&<FormGroup check>
                                  <Label check>
                                    <Input
                                      type="radio"
                                      name="radioOption"
                                      value={pricingPolicy.distributor_discount.value}
                                      checked={selectedProduct.pricingPolicyOption === pricingPolicy.distributor_discount.value}
                                      onChange={(e) =>
                                        handlePricePolicyChange(
                                            pricingPolicy.distributor_discount.value,
                                            '',
                                            "NO_SECTION"
                                        )
                                      }
                                    />
                                    {pricingPolicy.distributor_discount.label}
                                  </Label>
                                </FormGroup>}
                                <FormGroup check>
                                  <Label check>
                                    <Input
                                      type="radio"
                                      name="radioOption"
                                      value={pricingPolicy.manufacture_discount.value}
                                      checked={selectedProduct.pricingPolicyOption === pricingPolicy.manufacture_discount.value}
                                      onChange={(e) =>
                                        handlePricePolicyChange(
                                            pricingPolicy.manufacture_discount.value,
                                            '',
                                            "NO_SECTION"
                                        )
                                      }
                                    />
                                    {pricingPolicy.manufacture_discount.label}
                                  </Label>
                                </FormGroup>
                              </div>
                            </FormGroup>
                            {/* <p>Selected Option: {selectedOption}</p> */}
                          </Form>
                      </Col>}

                      {/* Unit type */}
                      <Col md={2}>
                        <FormGroup>
                          <Label htmlFor="unit_type">Unit type:</Label>

                          <select
                            id="unit_type"
                            value={selectedProduct?.unit_type  || 'Ea'}
                            name="unit_type"
                            className="selectInput me-2"
                            onChange={(e) =>
                              handleUnitTypeChange(
                                e.target.value,
                                '',
                                "NO_SECTION"
                              )
                            }
                          >
                            <option value="">Select type</option>
                            {unitTypes.map((item,index) => (
                              <option key={index} value={item.value}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                          {noSectionFormInputErrorMessage
                            ?.unit_type && (
                            <div className="invalidError d-flex justify-content-center">
                              {
                                noSectionFormInputErrorMessage
                                  ?.unit_type
                              }
                            </div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Quantity */}
                      <Col md={2}>
                        <FormGroup>
                          <Label htmlFor="main_quantity">Quantity:</Label>
                          <Input
                            type="number"
                            value={selectedProduct?.quantity}

                            onChange={(e) =>{
                              const value = e.target.value;
                         
                                handleQuantityChange(
                                  selectedProduct.pricingPolicyOption,
                                  value,
                                  '',
                                  "NO_SECTION"
                                )
                              
                            }
                            }
                            id="quantity"
                            name="quantity"
                          />
                          {noSectionFormInputErrorMessage
                            ?.quantity && (
                            <div className="invalidError d-flex justify-content-center">
                              {
                                noSectionFormInputErrorMessage
                                  ?.quantity
                              }
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                      {/* Discount */}
                      {selectedProduct.pricingPolicyOption !== pricingPolicy.standard_pricing.value && <Col md={2}>
                        <FormGroup>
                          <Label htmlFor="main_quantity">Discount (%):</Label>
                          <Input
                            type="number"
                            value={selectedProduct?.pricing_policy_discount?.value || '0'}
                            onChange={(e) =>{
                              const value = e.target.value;
                         
                                handlePricingPolicyDiscountChange(
                                  selectedProduct.pricingPolicyOption,
                                  value,
                                  '',
                                  "NO_SECTION"
                                )
                              
                            }
                            }
                            id="pricing_policy_discount"
                            name="pricing_policy_discount"
                          />
                          {noSectionFormInputErrorMessage
                            ?.quantity && (
                            <div className="invalidError d-flex justify-content-center">
                              {
                                noSectionFormInputErrorMessage
                                  ?.quantity
                              }
                            </div>
                          )}
                        </FormGroup>
                      </Col>}

                      {/* Markup+price*qty */}
                      <Col md={3}>
                          <FormGroup>
                            <Label>Total Price:</Label>
                              <Input
                                type="number"
                                value={selectedProduct?.markup_total_price || ""}
                                onChange={(e) =>{
                                  const value = e.target.value;
                                  handleTotalPriceChange(
                                      value,
                                      '',
                                      "NO_SECTION"
                                    )
                                }}
                              />
                          </FormGroup>
                      </Col>

                      <Col md={3}>
                        <FormGroup
                          style={{
                            position: "relative",
                            top: "28px",
                            right: "15px",
                          }}
                        >
                          <Button
                            color={`${isUpdateProductButtonNoSection ?  'success' : 'danger'} me-3`}
                            onClick={(e) =>
                              addProductToSection(
                                '',
                                "NO_SECTION"
                              )
                            }
                          >
                            {isUpdateProductButtonNoSection ?'Add product' : 'Update product'}
                          </Button>

                          {notSectionBaseSavedProduct.length !== 0 && (
                              <Button
                                color="info"
                                onClick={(e) => handleShowViewModal('', 'NO_SECTION')}
                              >
                                View products
                              </Button>
                            )}

                        </FormGroup>
                      </Col>

                      {/* Final Price*/}
                      <Row className="d-flex justify-content-end">
                        <Col md={3} className="d-flex justify-content-end mt-3">

                            <Label>Final Price: <span style={{color : 'red', fontSize : '18px'}}>{noSectionTotalProductFinalPrice}</span></Label>

                        </Col>
                      </Row>


                      </Row>
                </>} 
                {/* <-------------------------NOT SECTION END----------------------------> */}
                 
                <ViewPopUp {...viewModalProp} />
                   
                  <hr/>
                  {/* <------------------TERMS & CONDITION--------------------> */}
                  <Col md={12}>
                      <Card style={{ border: "1px solid #ced4da", }}>
                      <Accordion flush open={termsConditionAccordion} toggle={handleTermsConditionAccordion}>
                        <AccordionItem>
                          <AccordionHeader targetId="1" style={{ backgroundColor: '#d5f1d1' }}>
                            <b>Terms & Conditions</b>
                          </AccordionHeader>
                          <AccordionBody accordionId="1">
                            <Row>
                              <Col md={6}>
                                <FormGroup>
                                  <Label htmlFor="validity_period">Quotation Validity:</Label>
                                  <Input
                                    type="text"
                                    value={quotationForm.values.quote_validity_period}
                                    required
                                    onChange={quotationForm.handleChange}
                                    placeholder="e.g., 30 Days From The Date of Quotation"
                                    id="validity_period"
                                    name="quote_validity_period"
                                  />
                                </FormGroup>
                              </Col>
                              {/* <Col md={6}>
                                <FormGroup>
                                  <Label htmlFor="quot_delivery_terms">Delivery Time:</Label>
                                  <textarea
                                    value={quotationForm.values.quote_delivery_terms}
                                    className="selectInput"
                                    placeholder="e.g., 6-12 Weeks After PO and Advance Payment"
                                    required
                                    onChange={quotationForm.handleChange}
                                    id="quot_delivery_terms"
                                    name="quote_delivery_terms"
                                />
                                </FormGroup>
                              </Col> */}
                              <Col md={6}>
                                <FormGroup>
                                  <Label htmlFor="payment_structure">Payment Structure:</Label>
                                  <textarea
                                    value={quotationForm.values.quote_payment_structure}
                                    className="selectInput"
                                    required
                                    placeholder="e.g., 60% Advance, 30% Upon Material Delivery, 10% After Completion"
                                    onChange={quotationForm.handleChange}
                                    id="payment_structure "
                                    name="quote_payment_structure"
                                />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Col md={12}>
                              <FormGroup>
                                <Label htmlFor="terms_condition">Enter Terms and Conditions:</Label>
                                <div className="d-flex">
                                  <Input
                                    type="text"
                                    value={newTerm}
                                    className="me-2"
                                    onChange={(e) => setNewTerm(e.target.value)}
                                    id="terms_condition"
                                    name="terms_condition"
                                  />
                                  <Button color="success" onClick={addTermsAndCondition}>
                                    Add
                                  </Button>
                                </div>
                              </FormGroup>
                            </Col>

                            {/* Check all */}
                            <Col md={12} className="mb-2">
                              <FormGroup check >
                                  <Input type="checkbox" 
                                    // checked={term.checked} 
                                    onClick={(e)=>handleAllCheckboxChange(e.target.checked)}
                                  />
                                  <Label check >
                                        Check All
                                  </Label>
                              </FormGroup>
                            </Col>
                            {/* Dynamically render the list of terms with checkboxes */}
                            {termsAndConditions?.map((term, index) => (
                              <Col md={12} key={index}>
                                <FormGroup check >
                                  <Input type="checkbox" checked={term.checked} onClick={(e)=>handleCheckboxChange(index, e.target.checked)}/>
                                  <div className="d-flex justify-content-between termsConditionDelete">
                                      <Label check>
                                        {term.description}
                                      </Label>
                                      <button type="button" size="sm" onClick={() => deleteTerm(term.id)}>
                                        <i class="bi bi-x"></i>
                                      </button>
                                  </div>
                                </FormGroup>
                              </Col>
                            ))}
                          </AccordionBody>
                        </AccordionItem>
                      </Accordion>
                      </Card>
                  </Col>
       
                  <Row>
                      {/* <Col md={4}>
                        <FormGroup>
                          <Label htmlFor="lead_time">Lead time (Days):</Label>
                          <div className="d-flex">
                            <Input
                              type="text"
                              value={quotationForm.values.lead_time}
                              required
                              onChange={quotationForm.handleChange}
                              id="lead_time"
                              name="lead_time"
                            />
                          </div>
                        </FormGroup>
                      </Col> */}
                      <Col md={4}>
                        <FormGroup>
                          <Label htmlFor="saber_fee">Saber fee:</Label>
                          <div className="d-flex">
                            <Input
                              type="text"
                              value={quotationForm.values.saber_fee}
                              // onChange={quotationForm.handleChange}
                              onChange={(e)=>handleChangeSaberFee(e.target.value)}
                              id="saber_fee"
                              name="saber_fee"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label htmlFor="discount">Discount (%):</Label>
                          <div className="d-flex">
                            <Input
                              type="number"
                              value={appliedDiscount}
                              onChange={(e)=>handleDiscountChange(e.target.value)}
                              id="discount"
                              name="discount"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                  </Row>
                  {/* Calculation */}
                  <Row>
                      <Col md={3}>
                        <FormGroup>
                          <Label htmlFor="tax_amount">Total tax amount:</Label>
                          <div className="d-flex">
                            <Input
                              type="text"
                              readOnly
                              value={totalTaxAmount}
                              id="tax_amount"
                              name="total_tax_amount"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label htmlFor="discount_amount">Total discount amount:</Label>
                          <div className="d-flex">
                            <Input
                              type="number"
                              required
                              readOnly
                              value={totalDiscountedPrice}
                              id="discount_amount"
                              name="total_discount_amount"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label htmlFor="markup_amount">Total markup amount:</Label>
                          <div className="d-flex">
                            <Input
                              type="text"
                              value={totalMarkupAmount}
                              readOnly
                              id="markup_amount"
                              name="total_markup_amount"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label htmlFor="final_amount">Total final amount:</Label>
                          <div className="d-flex">
                            <Input
                              type="text"
                              readOnly
             
                              value={totalFinalAmount}
                              id="final_amount"
                              name="total_final_amount"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                  </Row>
              </Row>
            </Row>
            <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            {/* </FormGroup> */}
            <Button color="danger" onClick={handleShow}>
              Cancel
            </Button>
          </ModalFooter>
          </ModalBody>
        </Form>
      </div>
    </Modal>
  );
}

export default OpenPopUp;
